/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as SharedArenaRouteImport } from './routes/shared-arena'
import { Route as OnboardingNewRouteImport } from './routes/onboarding-new'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DesktopLoginRouteImport } from './routes/desktop-login'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as ChannelsRouteImport } from './routes/_channels'
import { Route as BrowserRequestRouteImport } from './routes/_browser-request'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthCallbackIndexRouteImport } from './routes/auth-callback/index'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as WrappedShareIdRouteImport } from './routes/wrapped.$shareId'
import { Route as TeamJoinRouteImport } from './routes/team/join'
import { Route as SharedMeetingIdRouteImport } from './routes/shared-meeting.$id'
import { Route as SharedChatIdRouteImport } from './routes/shared-chat.$id'
import { Route as FTokenRouteImport } from './routes/f.$token'
import { Route as ErrorSessionExpiredRouteImport } from './routes/error/session-expired'
import { Route as ChannelsSignInRouteImport } from './routes/channels.sign-in'
import { Route as ChangeEmailVerifyRouteImport } from './routes/change-email/verify'
import { Route as AuthCallbackDesktopRouteImport } from './routes/auth-callback/desktop'
import { Route as ArtifactTokenRouteImport } from './routes/artifact.$token'
import { Route as ChannelsChannelsRouteImport } from './routes/_channels/channels'
import { Route as AuthenticatedMeetingsRouteImport } from './routes/_authenticated/meetings'
import { Route as AuthenticatedWorldModelIndexRouteImport } from './routes/_authenticated/world-model/index'
import { Route as AuthenticatedWelcomeIndexRouteImport } from './routes/_authenticated/welcome/index'
import { Route as AuthenticatedSummaryTimelineIndexRouteImport } from './routes/_authenticated/summary-timeline/index'
import { Route as AuthenticatedSpritesIndexRouteImport } from './routes/_authenticated/sprites/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedRoutinesIndexRouteImport } from './routes/_authenticated/routines/index'
import { Route as AuthenticatedRoutineChatsIndexRouteImport } from './routes/_authenticated/routine-chats.index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedPeopleWikiIndexRouteImport } from './routes/_authenticated/people-wiki/index'
import { Route as AuthenticatedMeetingsIndexRouteImport } from './routes/_authenticated/meetings/index'
import { Route as AuthenticatedMeetingDebugIndexRouteImport } from './routes/_authenticated/meeting-debug/index'
import { Route as AuthenticatedMcpInfoIndexRouteImport } from './routes/_authenticated/mcp-info/index'
import { Route as AuthenticatedJournalIndexRouteImport } from './routes/_authenticated/journal/index'
import { Route as AuthenticatedIntegrationsIndexRouteImport } from './routes/_authenticated/integrations/index'
import { Route as AuthenticatedIngestionIndexRouteImport } from './routes/_authenticated/ingestion/index'
import { Route as AuthenticatedFeedIndexRouteImport } from './routes/_authenticated/feed/index'
import { Route as AuthenticatedEchonotesIndexRouteImport } from './routes/_authenticated/echonotes/index'
import { Route as AuthenticatedDebugIndexRouteImport } from './routes/_authenticated/debug/index'
import { Route as AuthenticatedCkDebugIndexRouteImport } from './routes/_authenticated/ck-debug/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedChannelSimulatorIndexRouteImport } from './routes/_authenticated/channel-simulator/index'
import { Route as AuthenticatedBirdGameIndexRouteImport } from './routes/_authenticated/bird-game/index'
import { Route as AuthenticatedArenaIndexRouteImport } from './routes/_authenticated/arena/index'
import { Route as AuthenticatedActivityTimelineIndexRouteImport } from './routes/_authenticated/activity-timeline/index'
import { Route as ProjectsJoinTokenRouteImport } from './routes/projects.join.$token'
import { Route as ChannelsChannelsUpgradeRouteImport } from './routes/_channels/channels/upgrade'
import { Route as ChannelsChannelsOnboardingRouteImport } from './routes/_channels/channels/onboarding'
import { Route as BrowserRequestBrowserSignInSignInSessionIdRouteImport } from './routes/_browser-request/browser-sign-in.$signInSessionId'
import { Route as BrowserRequestBrowserSavedCredentialRequestIdRouteImport } from './routes/_browser-request/browser-saved-credential.$requestId'
import { Route as AuthenticatedSpritesSpriteIdRouteImport } from './routes/_authenticated/sprites/$spriteId'
import { Route as AuthenticatedSettingsSectionRouteImport } from './routes/_authenticated/settings/$section'
import { Route as AuthenticatedRoutinesRoutineIdRouteImport } from './routes/_authenticated/routines/$routineId'
import { Route as AuthenticatedRoutineChatsRoutineIdRouteImport } from './routes/_authenticated/routine-chats.$routineId'
import { Route as AuthenticatedReportsRoutineIdRouteImport } from './routes/_authenticated/reports/$routineId'
import { Route as AuthenticatedProjectsProjectIdRouteImport } from './routes/_authenticated/projects/$projectId'
import { Route as AuthenticatedPlaygroundCanvasRouteImport } from './routes/_authenticated/playground/canvas'
import { Route as AuthenticatedPlaygroundActionCardsV2RouteImport } from './routes/_authenticated/playground/action-cards-v2'
import { Route as AuthenticatedPeopleWikiPersonIdRouteImport } from './routes/_authenticated/people-wiki/$personId'
import { Route as AuthenticatedPPluginIdRouteImport } from './routes/_authenticated/p.$pluginId'
import { Route as AuthenticatedMeetingsMeetingIdRouteImport } from './routes/_authenticated/meetings/$meetingId'
import { Route as AuthenticatedJournalJournalIdRouteImport } from './routes/_authenticated/journal/$journalId'
import { Route as AuthenticatedChatsAllRouteImport } from './routes/_authenticated/chats/all'
import { Route as AuthenticatedChatsChatIdRouteImport } from './routes/_authenticated/chats/$chatId'
import { Route as AuthenticatedArenaArenaIdRouteImport } from './routes/_authenticated/arena/$arenaId'
import { Route as AuthenticatedAgentsNewTaskRouteImport } from './routes/_authenticated/agents/new-task'
import { Route as AuthenticatedAgentsAttentionRouteImport } from './routes/_authenticated/agents/attention'
import { Route as AuthenticatedProjectsProjectIdSharedItemTypeItemIdRouteImport } from './routes/_authenticated/projects/$projectId_.shared.$itemType.$itemId'

const LinkLazyRouteImport = createFileRoute('/link')()
const AccountSupportLazyRouteImport = createFileRoute('/account/support')()
const AccountDeleteLazyRouteImport = createFileRoute('/account/delete')()
const ChannelsChannelsIndexLazyRouteImport = createFileRoute(
  '/_channels/channels/',
)()
const ChannelsChannelsSettingsLazyRouteImport = createFileRoute(
  '/_channels/channels/settings',
)()
const ChannelsChannelsRoutinesLazyRouteImport = createFileRoute(
  '/_channels/channels/routines',
)()
const ChannelsChannelsIntegrationsLazyRouteImport = createFileRoute(
  '/_channels/channels/integrations',
)()
const ChannelsChannelsConnectLazyRouteImport = createFileRoute(
  '/_channels/channels/connect',
)()
const AuthenticatedPlaygroundWidgetsLazyRouteImport = createFileRoute(
  '/_authenticated/playground/widgets',
)()
const AuthenticatedPlaygroundWhatsNewLazyRouteImport = createFileRoute(
  '/_authenticated/playground/whats-new',
)()
const AuthenticatedPlaygroundVlistOverlapLazyRouteImport = createFileRoute(
  '/_authenticated/playground/vlist-overlap',
)()
const AuthenticatedPlaygroundTypographyLazyRouteImport = createFileRoute(
  '/_authenticated/playground/typography',
)()
const AuthenticatedPlaygroundTranscriptionInputDeviceLazyRouteImport =
  createFileRoute('/_authenticated/playground/transcription-input-device')()
const AuthenticatedPlaygroundTranscriptStreamingLazyRouteImport =
  createFileRoute('/_authenticated/playground/transcript-streaming')()
const AuthenticatedPlaygroundToastsLazyRouteImport = createFileRoute(
  '/_authenticated/playground/toasts',
)()
const AuthenticatedPlaygroundTeamPlanLazyRouteImport = createFileRoute(
  '/_authenticated/playground/team-plan',
)()
const AuthenticatedPlaygroundSubscriptionLazyRouteImport = createFileRoute(
  '/_authenticated/playground/subscription',
)()
const AuthenticatedPlaygroundSoundsLazyRouteImport = createFileRoute(
  '/_authenticated/playground/sounds',
)()
const AuthenticatedPlaygroundSmoothdownLazyRouteImport = createFileRoute(
  '/_authenticated/playground/smoothdown',
)()
const AuthenticatedPlaygroundSendDraftCardLazyRouteImport = createFileRoute(
  '/_authenticated/playground/send-draft-card',
)()
const AuthenticatedPlaygroundReasoningLazyRouteImport = createFileRoute(
  '/_authenticated/playground/reasoning',
)()
const AuthenticatedPlaygroundNotificationsLazyRouteImport = createFileRoute(
  '/_authenticated/playground/notifications',
)()
const AuthenticatedPlaygroundMeetingsEmptyStateLazyRouteImport =
  createFileRoute('/_authenticated/playground/meetings-empty-state')()
const AuthenticatedPlaygroundMarkdownEditorLazyRouteImport = createFileRoute(
  '/_authenticated/playground/markdown-editor',
)()
const AuthenticatedPlaygroundLiveRegionLazyRouteImport = createFileRoute(
  '/_authenticated/playground/live-region',
)()
const AuthenticatedPlaygroundIconsLazyRouteImport = createFileRoute(
  '/_authenticated/playground/icons',
)()
const AuthenticatedPlaygroundFindLazyRouteImport = createFileRoute(
  '/_authenticated/playground/find',
)()
const AuthenticatedPlaygroundFastScrollBarLazyRouteImport = createFileRoute(
  '/_authenticated/playground/fast-scroll-bar',
)()
const AuthenticatedPlaygroundEmptyStatesLazyRouteImport = createFileRoute(
  '/_authenticated/playground/empty-states',
)()
const AuthenticatedPlaygroundEditorPreviewParityLazyRouteImport =
  createFileRoute('/_authenticated/playground/editor-preview-parity')()
const AuthenticatedPlaygroundEditorFindIsolationLazyRouteImport =
  createFileRoute('/_authenticated/playground/editor-find-isolation')()
const AuthenticatedPlaygroundEditorLazyRouteImport = createFileRoute(
  '/_authenticated/playground/editor',
)()
const AuthenticatedPlaygroundEditableTablesLazyRouteImport = createFileRoute(
  '/_authenticated/playground/editable-tables',
)()
const AuthenticatedPlaygroundColorsLazyRouteImport = createFileRoute(
  '/_authenticated/playground/colors',
)()
const AuthenticatedPlaygroundCalendarLazyRouteImport = createFileRoute(
  '/_authenticated/playground/calendar',
)()
const AuthenticatedPlaygroundButtonsLazyRouteImport = createFileRoute(
  '/_authenticated/playground/buttons',
)()
const AuthenticatedPlaygroundBirdThinkingStatesLazyRouteImport =
  createFileRoute('/_authenticated/playground/bird-thinking-states')()
const AuthenticatedPlaygroundBannerLazyRouteImport = createFileRoute(
  '/_authenticated/playground/banner',
)()
const AuthenticatedPlaygroundAskUserQuestionsLazyRouteImport = createFileRoute(
  '/_authenticated/playground/ask-user-questions',
)()
const AuthenticatedPlaygroundArtifactsLazyRouteImport = createFileRoute(
  '/_authenticated/playground/artifacts',
)()

const LinkLazyRoute = LinkLazyRouteImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/link.lazy').then((d) => d.Route))
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/verify-email.lazy').then((d) => d.Route))
const UpgradeRoute = UpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedArenaRoute = SharedArenaRouteImport.update({
  id: '/shared-arena',
  path: '/shared-arena',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/shared-arena.lazy').then((d) => d.Route))
const OnboardingNewRoute = OnboardingNewRouteImport.update({
  id: '/onboarding-new',
  path: '/onboarding-new',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/onboarding.lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const DesktopLoginRoute = DesktopLoginRouteImport.update({
  id: '/desktop-login',
  path: '/desktop-login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/desktop-login.lazy').then((d) => d.Route))
const AccessibilityRoute = AccessibilityRouteImport.update({
  id: '/accessibility',
  path: '/accessibility',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/accessibility.lazy').then((d) => d.Route))
const ChannelsRoute = ChannelsRouteImport.update({
  id: '/_channels',
  getParentRoute: () => rootRouteImport,
} as any)
const BrowserRequestRoute = BrowserRequestRouteImport.update({
  id: '/_browser-request',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackIndexRoute = AuthCallbackIndexRouteImport.update({
  id: '/auth-callback/',
  path: '/auth-callback/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AccountSupportLazyRoute = AccountSupportLazyRouteImport.update({
  id: '/account/support',
  path: '/account/support',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/account/support.lazy').then((d) => d.Route),
)
const AccountDeleteLazyRoute = AccountDeleteLazyRouteImport.update({
  id: '/account/delete',
  path: '/account/delete',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/account/delete.lazy').then((d) => d.Route),
)
const WrappedShareIdRoute = WrappedShareIdRouteImport.update({
  id: '/wrapped/$shareId',
  path: '/wrapped/$shareId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/wrapped.$shareId.lazy').then((d) => d.Route),
)
const TeamJoinRoute = TeamJoinRouteImport.update({
  id: '/team/join',
  path: '/team/join',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedMeetingIdRoute = SharedMeetingIdRouteImport.update({
  id: '/shared-meeting/$id',
  path: '/shared-meeting/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/shared-meeting.$id.lazy').then((d) => d.Route),
)
const SharedChatIdRoute = SharedChatIdRouteImport.update({
  id: '/shared-chat/$id',
  path: '/shared-chat/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/shared-chat.$id.lazy').then((d) => d.Route),
)
const FTokenRoute = FTokenRouteImport.update({
  id: '/f/$token',
  path: '/f/$token',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/f.$token.lazy').then((d) => d.Route))
const ErrorSessionExpiredRoute = ErrorSessionExpiredRouteImport.update({
  id: '/error/session-expired',
  path: '/error/session-expired',
  getParentRoute: () => rootRouteImport,
} as any)
const ChannelsSignInRoute = ChannelsSignInRouteImport.update({
  id: '/channels/sign-in',
  path: '/channels/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangeEmailVerifyRoute = ChangeEmailVerifyRouteImport.update({
  id: '/change-email/verify',
  path: '/change-email/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackDesktopRoute = AuthCallbackDesktopRouteImport.update({
  id: '/auth-callback/desktop',
  path: '/auth-callback/desktop',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtifactTokenRoute = ArtifactTokenRouteImport.update({
  id: '/artifact/$token',
  path: '/artifact/$token',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/artifact.$token.lazy').then((d) => d.Route),
)
const ChannelsChannelsRoute = ChannelsChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => ChannelsRoute,
} as any)
const AuthenticatedMeetingsRoute = AuthenticatedMeetingsRouteImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ChannelsChannelsIndexLazyRoute =
  ChannelsChannelsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ChannelsChannelsRoute,
  } as any).lazy(() =>
    import('./routes/_channels/channels/index.lazy').then((d) => d.Route),
  )
const AuthenticatedWorldModelIndexRoute =
  AuthenticatedWorldModelIndexRouteImport.update({
    id: '/world-model/',
    path: '/world-model/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWelcomeIndexRoute =
  AuthenticatedWelcomeIndexRouteImport.update({
    id: '/welcome/',
    path: '/welcome/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSummaryTimelineIndexRoute =
  AuthenticatedSummaryTimelineIndexRouteImport.update({
    id: '/summary-timeline/',
    path: '/summary-timeline/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSpritesIndexRoute =
  AuthenticatedSpritesIndexRouteImport.update({
    id: '/sprites/',
    path: '/sprites/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoutinesIndexRoute =
  AuthenticatedRoutinesIndexRouteImport.update({
    id: '/routines/',
    path: '/routines/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoutineChatsIndexRoute =
  AuthenticatedRoutineChatsIndexRouteImport.update({
    id: '/routine-chats/',
    path: '/routine-chats/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPeopleWikiIndexRoute =
  AuthenticatedPeopleWikiIndexRouteImport.update({
    id: '/people-wiki/',
    path: '/people-wiki/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMeetingsIndexRoute =
  AuthenticatedMeetingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMeetingsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/meetings/index.lazy').then((d) => d.Route),
  )
const AuthenticatedMeetingDebugIndexRoute =
  AuthenticatedMeetingDebugIndexRouteImport.update({
    id: '/meeting-debug/',
    path: '/meeting-debug/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMcpInfoIndexRoute =
  AuthenticatedMcpInfoIndexRouteImport.update({
    id: '/mcp-info/',
    path: '/mcp-info/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJournalIndexRoute =
  AuthenticatedJournalIndexRouteImport.update({
    id: '/journal/',
    path: '/journal/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntegrationsIndexRoute =
  AuthenticatedIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIngestionIndexRoute =
  AuthenticatedIngestionIndexRouteImport.update({
    id: '/ingestion/',
    path: '/ingestion/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFeedIndexRoute = AuthenticatedFeedIndexRouteImport.update({
  id: '/feed/',
  path: '/feed/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEchonotesIndexRoute =
  AuthenticatedEchonotesIndexRouteImport.update({
    id: '/echonotes/',
    path: '/echonotes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDebugIndexRoute = AuthenticatedDebugIndexRouteImport.update({
  id: '/debug/',
  path: '/debug/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCkDebugIndexRoute =
  AuthenticatedCkDebugIndexRouteImport.update({
    id: '/ck-debug/',
    path: '/ck-debug/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChannelSimulatorIndexRoute =
  AuthenticatedChannelSimulatorIndexRouteImport.update({
    id: '/channel-simulator/',
    path: '/channel-simulator/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBirdGameIndexRoute =
  AuthenticatedBirdGameIndexRouteImport.update({
    id: '/bird-game/',
    path: '/bird-game/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArenaIndexRoute = AuthenticatedArenaIndexRouteImport.update({
  id: '/arena/',
  path: '/arena/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActivityTimelineIndexRoute =
  AuthenticatedActivityTimelineIndexRouteImport.update({
    id: '/activity-timeline/',
    path: '/activity-timeline/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const ChannelsChannelsSettingsLazyRoute =
  ChannelsChannelsSettingsLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ChannelsChannelsRoute,
  } as any).lazy(() =>
    import('./routes/_channels/channels/settings.lazy').then((d) => d.Route),
  )
const ChannelsChannelsRoutinesLazyRoute =
  ChannelsChannelsRoutinesLazyRouteImport.update({
    id: '/routines',
    path: '/routines',
    getParentRoute: () => ChannelsChannelsRoute,
  } as any).lazy(() =>
    import('./routes/_channels/channels/routines.lazy').then((d) => d.Route),
  )
const ChannelsChannelsIntegrationsLazyRoute =
  ChannelsChannelsIntegrationsLazyRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => ChannelsChannelsRoute,
  } as any).lazy(() =>
    import('./routes/_channels/channels/integrations.lazy').then(
      (d) => d.Route,
    ),
  )
const ChannelsChannelsConnectLazyRoute =
  ChannelsChannelsConnectLazyRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => ChannelsChannelsRoute,
  } as any).lazy(() =>
    import('./routes/_channels/channels/connect.lazy').then((d) => d.Route),
  )
const AuthenticatedPlaygroundWidgetsLazyRoute =
  AuthenticatedPlaygroundWidgetsLazyRouteImport.update({
    id: '/playground/widgets',
    path: '/playground/widgets',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/widgets.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundWhatsNewLazyRoute =
  AuthenticatedPlaygroundWhatsNewLazyRouteImport.update({
    id: '/playground/whats-new',
    path: '/playground/whats-new',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/whats-new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundVlistOverlapLazyRoute =
  AuthenticatedPlaygroundVlistOverlapLazyRouteImport.update({
    id: '/playground/vlist-overlap',
    path: '/playground/vlist-overlap',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/vlist-overlap.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundTypographyLazyRoute =
  AuthenticatedPlaygroundTypographyLazyRouteImport.update({
    id: '/playground/typography',
    path: '/playground/typography',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/typography.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundTranscriptionInputDeviceLazyRoute =
  AuthenticatedPlaygroundTranscriptionInputDeviceLazyRouteImport.update({
    id: '/playground/transcription-input-device',
    path: '/playground/transcription-input-device',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/transcription-input-device.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundTranscriptStreamingLazyRoute =
  AuthenticatedPlaygroundTranscriptStreamingLazyRouteImport.update({
    id: '/playground/transcript-streaming',
    path: '/playground/transcript-streaming',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/transcript-streaming.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundToastsLazyRoute =
  AuthenticatedPlaygroundToastsLazyRouteImport.update({
    id: '/playground/toasts',
    path: '/playground/toasts',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/toasts.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundTeamPlanLazyRoute =
  AuthenticatedPlaygroundTeamPlanLazyRouteImport.update({
    id: '/playground/team-plan',
    path: '/playground/team-plan',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/team-plan.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundSubscriptionLazyRoute =
  AuthenticatedPlaygroundSubscriptionLazyRouteImport.update({
    id: '/playground/subscription',
    path: '/playground/subscription',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/subscription.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundSoundsLazyRoute =
  AuthenticatedPlaygroundSoundsLazyRouteImport.update({
    id: '/playground/sounds',
    path: '/playground/sounds',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/sounds.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundSmoothdownLazyRoute =
  AuthenticatedPlaygroundSmoothdownLazyRouteImport.update({
    id: '/playground/smoothdown',
    path: '/playground/smoothdown',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/smoothdown.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundSendDraftCardLazyRoute =
  AuthenticatedPlaygroundSendDraftCardLazyRouteImport.update({
    id: '/playground/send-draft-card',
    path: '/playground/send-draft-card',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/send-draft-card.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundReasoningLazyRoute =
  AuthenticatedPlaygroundReasoningLazyRouteImport.update({
    id: '/playground/reasoning',
    path: '/playground/reasoning',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/reasoning.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundNotificationsLazyRoute =
  AuthenticatedPlaygroundNotificationsLazyRouteImport.update({
    id: '/playground/notifications',
    path: '/playground/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/notifications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundMeetingsEmptyStateLazyRoute =
  AuthenticatedPlaygroundMeetingsEmptyStateLazyRouteImport.update({
    id: '/playground/meetings-empty-state',
    path: '/playground/meetings-empty-state',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/meetings-empty-state.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundMarkdownEditorLazyRoute =
  AuthenticatedPlaygroundMarkdownEditorLazyRouteImport.update({
    id: '/playground/markdown-editor',
    path: '/playground/markdown-editor',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/markdown-editor.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundLiveRegionLazyRoute =
  AuthenticatedPlaygroundLiveRegionLazyRouteImport.update({
    id: '/playground/live-region',
    path: '/playground/live-region',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/live-region.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundIconsLazyRoute =
  AuthenticatedPlaygroundIconsLazyRouteImport.update({
    id: '/playground/icons',
    path: '/playground/icons',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/icons.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundFindLazyRoute =
  AuthenticatedPlaygroundFindLazyRouteImport.update({
    id: '/playground/find',
    path: '/playground/find',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/find.lazy').then((d) => d.Route),
  )
const AuthenticatedPlaygroundFastScrollBarLazyRoute =
  AuthenticatedPlaygroundFastScrollBarLazyRouteImport.update({
    id: '/playground/fast-scroll-bar',
    path: '/playground/fast-scroll-bar',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/fast-scroll-bar.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundEmptyStatesLazyRoute =
  AuthenticatedPlaygroundEmptyStatesLazyRouteImport.update({
    id: '/playground/empty-states',
    path: '/playground/empty-states',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/empty-states.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundEditorPreviewParityLazyRoute =
  AuthenticatedPlaygroundEditorPreviewParityLazyRouteImport.update({
    id: '/playground/editor-preview-parity',
    path: '/playground/editor-preview-parity',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/editor-preview-parity.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundEditorFindIsolationLazyRoute =
  AuthenticatedPlaygroundEditorFindIsolationLazyRouteImport.update({
    id: '/playground/editor-find-isolation',
    path: '/playground/editor-find-isolation',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/editor-find-isolation.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundEditorLazyRoute =
  AuthenticatedPlaygroundEditorLazyRouteImport.update({
    id: '/playground/editor',
    path: '/playground/editor',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/editor.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundEditableTablesLazyRoute =
  AuthenticatedPlaygroundEditableTablesLazyRouteImport.update({
    id: '/playground/editable-tables',
    path: '/playground/editable-tables',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/editable-tables.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundColorsLazyRoute =
  AuthenticatedPlaygroundColorsLazyRouteImport.update({
    id: '/playground/colors',
    path: '/playground/colors',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/colors.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundCalendarLazyRoute =
  AuthenticatedPlaygroundCalendarLazyRouteImport.update({
    id: '/playground/calendar',
    path: '/playground/calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/calendar.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundButtonsLazyRoute =
  AuthenticatedPlaygroundButtonsLazyRouteImport.update({
    id: '/playground/buttons',
    path: '/playground/buttons',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/buttons.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundBirdThinkingStatesLazyRoute =
  AuthenticatedPlaygroundBirdThinkingStatesLazyRouteImport.update({
    id: '/playground/bird-thinking-states',
    path: '/playground/bird-thinking-states',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/bird-thinking-states.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundBannerLazyRoute =
  AuthenticatedPlaygroundBannerLazyRouteImport.update({
    id: '/playground/banner',
    path: '/playground/banner',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/banner.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundAskUserQuestionsLazyRoute =
  AuthenticatedPlaygroundAskUserQuestionsLazyRouteImport.update({
    id: '/playground/ask-user-questions',
    path: '/playground/ask-user-questions',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/ask-user-questions.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundArtifactsLazyRoute =
  AuthenticatedPlaygroundArtifactsLazyRouteImport.update({
    id: '/playground/artifacts',
    path: '/playground/artifacts',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/artifacts.lazy').then(
      (d) => d.Route,
    ),
  )
const ProjectsJoinTokenRoute = ProjectsJoinTokenRouteImport.update({
  id: '/projects/join/$token',
  path: '/projects/join/$token',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/projects.join.$token.lazy').then((d) => d.Route),
)
const ChannelsChannelsUpgradeRoute = ChannelsChannelsUpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => ChannelsChannelsRoute,
} as any).lazy(() =>
  import('./routes/_channels/channels/upgrade.lazy').then((d) => d.Route),
)
const ChannelsChannelsOnboardingRoute =
  ChannelsChannelsOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => ChannelsChannelsRoute,
  } as any).lazy(() =>
    import('./routes/_channels/channels/onboarding.lazy').then((d) => d.Route),
  )
const BrowserRequestBrowserSignInSignInSessionIdRoute =
  BrowserRequestBrowserSignInSignInSessionIdRouteImport.update({
    id: '/browser-sign-in/$signInSessionId',
    path: '/browser-sign-in/$signInSessionId',
    getParentRoute: () => BrowserRequestRoute,
  } as any)
const BrowserRequestBrowserSavedCredentialRequestIdRoute =
  BrowserRequestBrowserSavedCredentialRequestIdRouteImport.update({
    id: '/browser-saved-credential/$requestId',
    path: '/browser-saved-credential/$requestId',
    getParentRoute: () => BrowserRequestRoute,
  } as any)
const AuthenticatedSpritesSpriteIdRoute =
  AuthenticatedSpritesSpriteIdRouteImport.update({
    id: '/sprites/$spriteId',
    path: '/sprites/$spriteId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSectionRoute =
  AuthenticatedSettingsSectionRouteImport.update({
    id: '/settings/$section',
    path: '/settings/$section',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/$section.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedRoutinesRoutineIdRoute =
  AuthenticatedRoutinesRoutineIdRouteImport.update({
    id: '/routines/$routineId',
    path: '/routines/$routineId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoutineChatsRoutineIdRoute =
  AuthenticatedRoutineChatsRoutineIdRouteImport.update({
    id: '/routine-chats/$routineId',
    path: '/routine-chats/$routineId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsRoutineIdRoute =
  AuthenticatedReportsRoutineIdRouteImport.update({
    id: '/reports/$routineId',
    path: '/reports/$routineId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdRoute =
  AuthenticatedProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlaygroundCanvasRoute =
  AuthenticatedPlaygroundCanvasRouteImport.update({
    id: '/playground/canvas',
    path: '/playground/canvas',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/canvas.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlaygroundActionCardsV2Route =
  AuthenticatedPlaygroundActionCardsV2RouteImport.update({
    id: '/playground/action-cards-v2',
    path: '/playground/action-cards-v2',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/playground/action-cards-v2.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPeopleWikiPersonIdRoute =
  AuthenticatedPeopleWikiPersonIdRouteImport.update({
    id: '/people-wiki/$personId',
    path: '/people-wiki/$personId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPPluginIdRoute = AuthenticatedPPluginIdRouteImport.update({
  id: '/p/$pluginId',
  path: '/p/$pluginId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMeetingsMeetingIdRoute =
  AuthenticatedMeetingsMeetingIdRouteImport.update({
    id: '/$meetingId',
    path: '/$meetingId',
    getParentRoute: () => AuthenticatedMeetingsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/meetings/$meetingId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJournalJournalIdRoute =
  AuthenticatedJournalJournalIdRouteImport.update({
    id: '/journal/$journalId',
    path: '/journal/$journalId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatsAllRoute = AuthenticatedChatsAllRouteImport.update({
  id: '/chats/all',
  path: '/chats/all',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChatsChatIdRoute =
  AuthenticatedChatsChatIdRouteImport.update({
    id: '/chats/$chatId',
    path: '/chats/$chatId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArenaArenaIdRoute =
  AuthenticatedArenaArenaIdRouteImport.update({
    id: '/arena/$arenaId',
    path: '/arena/$arenaId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgentsNewTaskRoute =
  AuthenticatedAgentsNewTaskRouteImport.update({
    id: '/agents/new-task',
    path: '/agents/new-task',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgentsAttentionRoute =
  AuthenticatedAgentsAttentionRouteImport.update({
    id: '/agents/attention',
    path: '/agents/attention',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdSharedItemTypeItemIdRoute =
  AuthenticatedProjectsProjectIdSharedItemTypeItemIdRouteImport.update({
    id: '/projects/$projectId_/shared/$itemType/$itemId',
    path: '/projects/$projectId/shared/$itemType/$itemId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/accessibility': typeof AccessibilityRoute
  '/desktop-login': typeof DesktopLoginRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/onboarding-new': typeof OnboardingNewRoute
  '/shared-arena': typeof SharedArenaRoute
  '/upgrade': typeof UpgradeRoute
  '/verify-email': typeof VerifyEmailRoute
  '/link': typeof LinkLazyRoute
  '/meetings': typeof AuthenticatedMeetingsRouteWithChildren
  '/channels': typeof ChannelsChannelsRouteWithChildren
  '/artifact/$token': typeof ArtifactTokenRoute
  '/auth-callback/desktop': typeof AuthCallbackDesktopRoute
  '/change-email/verify': typeof ChangeEmailVerifyRoute
  '/channels/sign-in': typeof ChannelsSignInRoute
  '/error/session-expired': typeof ErrorSessionExpiredRoute
  '/f/$token': typeof FTokenRoute
  '/shared-chat/$id': typeof SharedChatIdRoute
  '/shared-meeting/$id': typeof SharedMeetingIdRoute
  '/team/join': typeof TeamJoinRoute
  '/wrapped/$shareId': typeof WrappedShareIdRoute
  '/account/delete': typeof AccountDeleteLazyRoute
  '/account/support': typeof AccountSupportLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/auth-callback': typeof AuthCallbackIndexRoute
  '/agents/attention': typeof AuthenticatedAgentsAttentionRoute
  '/agents/new-task': typeof AuthenticatedAgentsNewTaskRoute
  '/arena/$arenaId': typeof AuthenticatedArenaArenaIdRoute
  '/chats/$chatId': typeof AuthenticatedChatsChatIdRoute
  '/chats/all': typeof AuthenticatedChatsAllRoute
  '/journal/$journalId': typeof AuthenticatedJournalJournalIdRoute
  '/meetings/$meetingId': typeof AuthenticatedMeetingsMeetingIdRoute
  '/p/$pluginId': typeof AuthenticatedPPluginIdRoute
  '/people-wiki/$personId': typeof AuthenticatedPeopleWikiPersonIdRoute
  '/playground/action-cards-v2': typeof AuthenticatedPlaygroundActionCardsV2Route
  '/playground/canvas': typeof AuthenticatedPlaygroundCanvasRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdRoute
  '/reports/$routineId': typeof AuthenticatedReportsRoutineIdRoute
  '/routine-chats/$routineId': typeof AuthenticatedRoutineChatsRoutineIdRoute
  '/routines/$routineId': typeof AuthenticatedRoutinesRoutineIdRoute
  '/settings/$section': typeof AuthenticatedSettingsSectionRoute
  '/sprites/$spriteId': typeof AuthenticatedSpritesSpriteIdRoute
  '/browser-saved-credential/$requestId': typeof BrowserRequestBrowserSavedCredentialRequestIdRoute
  '/browser-sign-in/$signInSessionId': typeof BrowserRequestBrowserSignInSignInSessionIdRoute
  '/channels/onboarding': typeof ChannelsChannelsOnboardingRoute
  '/channels/upgrade': typeof ChannelsChannelsUpgradeRoute
  '/projects/join/$token': typeof ProjectsJoinTokenRoute
  '/playground/artifacts': typeof AuthenticatedPlaygroundArtifactsLazyRoute
  '/playground/ask-user-questions': typeof AuthenticatedPlaygroundAskUserQuestionsLazyRoute
  '/playground/banner': typeof AuthenticatedPlaygroundBannerLazyRoute
  '/playground/bird-thinking-states': typeof AuthenticatedPlaygroundBirdThinkingStatesLazyRoute
  '/playground/buttons': typeof AuthenticatedPlaygroundButtonsLazyRoute
  '/playground/calendar': typeof AuthenticatedPlaygroundCalendarLazyRoute
  '/playground/colors': typeof AuthenticatedPlaygroundColorsLazyRoute
  '/playground/editable-tables': typeof AuthenticatedPlaygroundEditableTablesLazyRoute
  '/playground/editor': typeof AuthenticatedPlaygroundEditorLazyRoute
  '/playground/editor-find-isolation': typeof AuthenticatedPlaygroundEditorFindIsolationLazyRoute
  '/playground/editor-preview-parity': typeof AuthenticatedPlaygroundEditorPreviewParityLazyRoute
  '/playground/empty-states': typeof AuthenticatedPlaygroundEmptyStatesLazyRoute
  '/playground/fast-scroll-bar': typeof AuthenticatedPlaygroundFastScrollBarLazyRoute
  '/playground/find': typeof AuthenticatedPlaygroundFindLazyRoute
  '/playground/icons': typeof AuthenticatedPlaygroundIconsLazyRoute
  '/playground/live-region': typeof AuthenticatedPlaygroundLiveRegionLazyRoute
  '/playground/markdown-editor': typeof AuthenticatedPlaygroundMarkdownEditorLazyRoute
  '/playground/meetings-empty-state': typeof AuthenticatedPlaygroundMeetingsEmptyStateLazyRoute
  '/playground/notifications': typeof AuthenticatedPlaygroundNotificationsLazyRoute
  '/playground/reasoning': typeof AuthenticatedPlaygroundReasoningLazyRoute
  '/playground/send-draft-card': typeof AuthenticatedPlaygroundSendDraftCardLazyRoute
  '/playground/smoothdown': typeof AuthenticatedPlaygroundSmoothdownLazyRoute
  '/playground/sounds': typeof AuthenticatedPlaygroundSoundsLazyRoute
  '/playground/subscription': typeof AuthenticatedPlaygroundSubscriptionLazyRoute
  '/playground/team-plan': typeof AuthenticatedPlaygroundTeamPlanLazyRoute
  '/playground/toasts': typeof AuthenticatedPlaygroundToastsLazyRoute
  '/playground/transcript-streaming': typeof AuthenticatedPlaygroundTranscriptStreamingLazyRoute
  '/playground/transcription-input-device': typeof AuthenticatedPlaygroundTranscriptionInputDeviceLazyRoute
  '/playground/typography': typeof AuthenticatedPlaygroundTypographyLazyRoute
  '/playground/vlist-overlap': typeof AuthenticatedPlaygroundVlistOverlapLazyRoute
  '/playground/whats-new': typeof AuthenticatedPlaygroundWhatsNewLazyRoute
  '/playground/widgets': typeof AuthenticatedPlaygroundWidgetsLazyRoute
  '/channels/connect': typeof ChannelsChannelsConnectLazyRoute
  '/channels/integrations': typeof ChannelsChannelsIntegrationsLazyRoute
  '/channels/routines': typeof ChannelsChannelsRoutinesLazyRoute
  '/channels/settings': typeof ChannelsChannelsSettingsLazyRoute
  '/activity-timeline': typeof AuthenticatedActivityTimelineIndexRoute
  '/arena': typeof AuthenticatedArenaIndexRoute
  '/bird-game': typeof AuthenticatedBirdGameIndexRoute
  '/channel-simulator': typeof AuthenticatedChannelSimulatorIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/ck-debug': typeof AuthenticatedCkDebugIndexRoute
  '/debug': typeof AuthenticatedDebugIndexRoute
  '/echonotes': typeof AuthenticatedEchonotesIndexRoute
  '/feed': typeof AuthenticatedFeedIndexRoute
  '/ingestion': typeof AuthenticatedIngestionIndexRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexRoute
  '/journal': typeof AuthenticatedJournalIndexRoute
  '/mcp-info': typeof AuthenticatedMcpInfoIndexRoute
  '/meeting-debug': typeof AuthenticatedMeetingDebugIndexRoute
  '/meetings/': typeof AuthenticatedMeetingsIndexRoute
  '/people-wiki': typeof AuthenticatedPeopleWikiIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/routine-chats': typeof AuthenticatedRoutineChatsIndexRoute
  '/routines': typeof AuthenticatedRoutinesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/sprites': typeof AuthenticatedSpritesIndexRoute
  '/summary-timeline': typeof AuthenticatedSummaryTimelineIndexRoute
  '/welcome': typeof AuthenticatedWelcomeIndexRoute
  '/world-model': typeof AuthenticatedWorldModelIndexRoute
  '/channels/': typeof ChannelsChannelsIndexLazyRoute
  '/projects/$projectId/shared/$itemType/$itemId': typeof AuthenticatedProjectsProjectIdSharedItemTypeItemIdRoute
}
export interface FileRoutesByTo {
  '/accessibility': typeof AccessibilityRoute
  '/desktop-login': typeof DesktopLoginRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/onboarding-new': typeof OnboardingNewRoute
  '/shared-arena': typeof SharedArenaRoute
  '/upgrade': typeof UpgradeRoute
  '/verify-email': typeof VerifyEmailRoute
  '/link': typeof LinkLazyRoute
  '/artifact/$token': typeof ArtifactTokenRoute
  '/auth-callback/desktop': typeof AuthCallbackDesktopRoute
  '/change-email/verify': typeof ChangeEmailVerifyRoute
  '/channels/sign-in': typeof ChannelsSignInRoute
  '/error/session-expired': typeof ErrorSessionExpiredRoute
  '/f/$token': typeof FTokenRoute
  '/shared-chat/$id': typeof SharedChatIdRoute
  '/shared-meeting/$id': typeof SharedMeetingIdRoute
  '/team/join': typeof TeamJoinRoute
  '/wrapped/$shareId': typeof WrappedShareIdRoute
  '/account/delete': typeof AccountDeleteLazyRoute
  '/account/support': typeof AccountSupportLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/auth-callback': typeof AuthCallbackIndexRoute
  '/agents/attention': typeof AuthenticatedAgentsAttentionRoute
  '/agents/new-task': typeof AuthenticatedAgentsNewTaskRoute
  '/arena/$arenaId': typeof AuthenticatedArenaArenaIdRoute
  '/chats/$chatId': typeof AuthenticatedChatsChatIdRoute
  '/chats/all': typeof AuthenticatedChatsAllRoute
  '/journal/$journalId': typeof AuthenticatedJournalJournalIdRoute
  '/meetings/$meetingId': typeof AuthenticatedMeetingsMeetingIdRoute
  '/p/$pluginId': typeof AuthenticatedPPluginIdRoute
  '/people-wiki/$personId': typeof AuthenticatedPeopleWikiPersonIdRoute
  '/playground/action-cards-v2': typeof AuthenticatedPlaygroundActionCardsV2Route
  '/playground/canvas': typeof AuthenticatedPlaygroundCanvasRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdRoute
  '/reports/$routineId': typeof AuthenticatedReportsRoutineIdRoute
  '/routine-chats/$routineId': typeof AuthenticatedRoutineChatsRoutineIdRoute
  '/routines/$routineId': typeof AuthenticatedRoutinesRoutineIdRoute
  '/settings/$section': typeof AuthenticatedSettingsSectionRoute
  '/sprites/$spriteId': typeof AuthenticatedSpritesSpriteIdRoute
  '/browser-saved-credential/$requestId': typeof BrowserRequestBrowserSavedCredentialRequestIdRoute
  '/browser-sign-in/$signInSessionId': typeof BrowserRequestBrowserSignInSignInSessionIdRoute
  '/channels/onboarding': typeof ChannelsChannelsOnboardingRoute
  '/channels/upgrade': typeof ChannelsChannelsUpgradeRoute
  '/projects/join/$token': typeof ProjectsJoinTokenRoute
  '/playground/artifacts': typeof AuthenticatedPlaygroundArtifactsLazyRoute
  '/playground/ask-user-questions': typeof AuthenticatedPlaygroundAskUserQuestionsLazyRoute
  '/playground/banner': typeof AuthenticatedPlaygroundBannerLazyRoute
  '/playground/bird-thinking-states': typeof AuthenticatedPlaygroundBirdThinkingStatesLazyRoute
  '/playground/buttons': typeof AuthenticatedPlaygroundButtonsLazyRoute
  '/playground/calendar': typeof AuthenticatedPlaygroundCalendarLazyRoute
  '/playground/colors': typeof AuthenticatedPlaygroundColorsLazyRoute
  '/playground/editable-tables': typeof AuthenticatedPlaygroundEditableTablesLazyRoute
  '/playground/editor': typeof AuthenticatedPlaygroundEditorLazyRoute
  '/playground/editor-find-isolation': typeof AuthenticatedPlaygroundEditorFindIsolationLazyRoute
  '/playground/editor-preview-parity': typeof AuthenticatedPlaygroundEditorPreviewParityLazyRoute
  '/playground/empty-states': typeof AuthenticatedPlaygroundEmptyStatesLazyRoute
  '/playground/fast-scroll-bar': typeof AuthenticatedPlaygroundFastScrollBarLazyRoute
  '/playground/find': typeof AuthenticatedPlaygroundFindLazyRoute
  '/playground/icons': typeof AuthenticatedPlaygroundIconsLazyRoute
  '/playground/live-region': typeof AuthenticatedPlaygroundLiveRegionLazyRoute
  '/playground/markdown-editor': typeof AuthenticatedPlaygroundMarkdownEditorLazyRoute
  '/playground/meetings-empty-state': typeof AuthenticatedPlaygroundMeetingsEmptyStateLazyRoute
  '/playground/notifications': typeof AuthenticatedPlaygroundNotificationsLazyRoute
  '/playground/reasoning': typeof AuthenticatedPlaygroundReasoningLazyRoute
  '/playground/send-draft-card': typeof AuthenticatedPlaygroundSendDraftCardLazyRoute
  '/playground/smoothdown': typeof AuthenticatedPlaygroundSmoothdownLazyRoute
  '/playground/sounds': typeof AuthenticatedPlaygroundSoundsLazyRoute
  '/playground/subscription': typeof AuthenticatedPlaygroundSubscriptionLazyRoute
  '/playground/team-plan': typeof AuthenticatedPlaygroundTeamPlanLazyRoute
  '/playground/toasts': typeof AuthenticatedPlaygroundToastsLazyRoute
  '/playground/transcript-streaming': typeof AuthenticatedPlaygroundTranscriptStreamingLazyRoute
  '/playground/transcription-input-device': typeof AuthenticatedPlaygroundTranscriptionInputDeviceLazyRoute
  '/playground/typography': typeof AuthenticatedPlaygroundTypographyLazyRoute
  '/playground/vlist-overlap': typeof AuthenticatedPlaygroundVlistOverlapLazyRoute
  '/playground/whats-new': typeof AuthenticatedPlaygroundWhatsNewLazyRoute
  '/playground/widgets': typeof AuthenticatedPlaygroundWidgetsLazyRoute
  '/channels/connect': typeof ChannelsChannelsConnectLazyRoute
  '/channels/integrations': typeof ChannelsChannelsIntegrationsLazyRoute
  '/channels/routines': typeof ChannelsChannelsRoutinesLazyRoute
  '/channels/settings': typeof ChannelsChannelsSettingsLazyRoute
  '/activity-timeline': typeof AuthenticatedActivityTimelineIndexRoute
  '/arena': typeof AuthenticatedArenaIndexRoute
  '/bird-game': typeof AuthenticatedBirdGameIndexRoute
  '/channel-simulator': typeof AuthenticatedChannelSimulatorIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/ck-debug': typeof AuthenticatedCkDebugIndexRoute
  '/debug': typeof AuthenticatedDebugIndexRoute
  '/echonotes': typeof AuthenticatedEchonotesIndexRoute
  '/feed': typeof AuthenticatedFeedIndexRoute
  '/ingestion': typeof AuthenticatedIngestionIndexRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexRoute
  '/journal': typeof AuthenticatedJournalIndexRoute
  '/mcp-info': typeof AuthenticatedMcpInfoIndexRoute
  '/meeting-debug': typeof AuthenticatedMeetingDebugIndexRoute
  '/meetings': typeof AuthenticatedMeetingsIndexRoute
  '/people-wiki': typeof AuthenticatedPeopleWikiIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/routine-chats': typeof AuthenticatedRoutineChatsIndexRoute
  '/routines': typeof AuthenticatedRoutinesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/sprites': typeof AuthenticatedSpritesIndexRoute
  '/summary-timeline': typeof AuthenticatedSummaryTimelineIndexRoute
  '/welcome': typeof AuthenticatedWelcomeIndexRoute
  '/world-model': typeof AuthenticatedWorldModelIndexRoute
  '/channels': typeof ChannelsChannelsIndexLazyRoute
  '/projects/$projectId/shared/$itemType/$itemId': typeof AuthenticatedProjectsProjectIdSharedItemTypeItemIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_browser-request': typeof BrowserRequestRouteWithChildren
  '/_channels': typeof ChannelsRouteWithChildren
  '/accessibility': typeof AccessibilityRoute
  '/desktop-login': typeof DesktopLoginRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/onboarding-new': typeof OnboardingNewRoute
  '/shared-arena': typeof SharedArenaRoute
  '/upgrade': typeof UpgradeRoute
  '/verify-email': typeof VerifyEmailRoute
  '/link': typeof LinkLazyRoute
  '/_authenticated/meetings': typeof AuthenticatedMeetingsRouteWithChildren
  '/_channels/channels': typeof ChannelsChannelsRouteWithChildren
  '/artifact/$token': typeof ArtifactTokenRoute
  '/auth-callback/desktop': typeof AuthCallbackDesktopRoute
  '/change-email/verify': typeof ChangeEmailVerifyRoute
  '/channels/sign-in': typeof ChannelsSignInRoute
  '/error/session-expired': typeof ErrorSessionExpiredRoute
  '/f/$token': typeof FTokenRoute
  '/shared-chat/$id': typeof SharedChatIdRoute
  '/shared-meeting/$id': typeof SharedMeetingIdRoute
  '/team/join': typeof TeamJoinRoute
  '/wrapped/$shareId': typeof WrappedShareIdRoute
  '/account/delete': typeof AccountDeleteLazyRoute
  '/account/support': typeof AccountSupportLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/auth-callback/': typeof AuthCallbackIndexRoute
  '/_authenticated/agents/attention': typeof AuthenticatedAgentsAttentionRoute
  '/_authenticated/agents/new-task': typeof AuthenticatedAgentsNewTaskRoute
  '/_authenticated/arena/$arenaId': typeof AuthenticatedArenaArenaIdRoute
  '/_authenticated/chats/$chatId': typeof AuthenticatedChatsChatIdRoute
  '/_authenticated/chats/all': typeof AuthenticatedChatsAllRoute
  '/_authenticated/journal/$journalId': typeof AuthenticatedJournalJournalIdRoute
  '/_authenticated/meetings/$meetingId': typeof AuthenticatedMeetingsMeetingIdRoute
  '/_authenticated/p/$pluginId': typeof AuthenticatedPPluginIdRoute
  '/_authenticated/people-wiki/$personId': typeof AuthenticatedPeopleWikiPersonIdRoute
  '/_authenticated/playground/action-cards-v2': typeof AuthenticatedPlaygroundActionCardsV2Route
  '/_authenticated/playground/canvas': typeof AuthenticatedPlaygroundCanvasRoute
  '/_authenticated/projects/$projectId': typeof AuthenticatedProjectsProjectIdRoute
  '/_authenticated/reports/$routineId': typeof AuthenticatedReportsRoutineIdRoute
  '/_authenticated/routine-chats/$routineId': typeof AuthenticatedRoutineChatsRoutineIdRoute
  '/_authenticated/routines/$routineId': typeof AuthenticatedRoutinesRoutineIdRoute
  '/_authenticated/settings/$section': typeof AuthenticatedSettingsSectionRoute
  '/_authenticated/sprites/$spriteId': typeof AuthenticatedSpritesSpriteIdRoute
  '/_browser-request/browser-saved-credential/$requestId': typeof BrowserRequestBrowserSavedCredentialRequestIdRoute
  '/_browser-request/browser-sign-in/$signInSessionId': typeof BrowserRequestBrowserSignInSignInSessionIdRoute
  '/_channels/channels/onboarding': typeof ChannelsChannelsOnboardingRoute
  '/_channels/channels/upgrade': typeof ChannelsChannelsUpgradeRoute
  '/projects/join/$token': typeof ProjectsJoinTokenRoute
  '/_authenticated/playground/artifacts': typeof AuthenticatedPlaygroundArtifactsLazyRoute
  '/_authenticated/playground/ask-user-questions': typeof AuthenticatedPlaygroundAskUserQuestionsLazyRoute
  '/_authenticated/playground/banner': typeof AuthenticatedPlaygroundBannerLazyRoute
  '/_authenticated/playground/bird-thinking-states': typeof AuthenticatedPlaygroundBirdThinkingStatesLazyRoute
  '/_authenticated/playground/buttons': typeof AuthenticatedPlaygroundButtonsLazyRoute
  '/_authenticated/playground/calendar': typeof AuthenticatedPlaygroundCalendarLazyRoute
  '/_authenticated/playground/colors': typeof AuthenticatedPlaygroundColorsLazyRoute
  '/_authenticated/playground/editable-tables': typeof AuthenticatedPlaygroundEditableTablesLazyRoute
  '/_authenticated/playground/editor': typeof AuthenticatedPlaygroundEditorLazyRoute
  '/_authenticated/playground/editor-find-isolation': typeof AuthenticatedPlaygroundEditorFindIsolationLazyRoute
  '/_authenticated/playground/editor-preview-parity': typeof AuthenticatedPlaygroundEditorPreviewParityLazyRoute
  '/_authenticated/playground/empty-states': typeof AuthenticatedPlaygroundEmptyStatesLazyRoute
  '/_authenticated/playground/fast-scroll-bar': typeof AuthenticatedPlaygroundFastScrollBarLazyRoute
  '/_authenticated/playground/find': typeof AuthenticatedPlaygroundFindLazyRoute
  '/_authenticated/playground/icons': typeof AuthenticatedPlaygroundIconsLazyRoute
  '/_authenticated/playground/live-region': typeof AuthenticatedPlaygroundLiveRegionLazyRoute
  '/_authenticated/playground/markdown-editor': typeof AuthenticatedPlaygroundMarkdownEditorLazyRoute
  '/_authenticated/playground/meetings-empty-state': typeof AuthenticatedPlaygroundMeetingsEmptyStateLazyRoute
  '/_authenticated/playground/notifications': typeof AuthenticatedPlaygroundNotificationsLazyRoute
  '/_authenticated/playground/reasoning': typeof AuthenticatedPlaygroundReasoningLazyRoute
  '/_authenticated/playground/send-draft-card': typeof AuthenticatedPlaygroundSendDraftCardLazyRoute
  '/_authenticated/playground/smoothdown': typeof AuthenticatedPlaygroundSmoothdownLazyRoute
  '/_authenticated/playground/sounds': typeof AuthenticatedPlaygroundSoundsLazyRoute
  '/_authenticated/playground/subscription': typeof AuthenticatedPlaygroundSubscriptionLazyRoute
  '/_authenticated/playground/team-plan': typeof AuthenticatedPlaygroundTeamPlanLazyRoute
  '/_authenticated/playground/toasts': typeof AuthenticatedPlaygroundToastsLazyRoute
  '/_authenticated/playground/transcript-streaming': typeof AuthenticatedPlaygroundTranscriptStreamingLazyRoute
  '/_authenticated/playground/transcription-input-device': typeof AuthenticatedPlaygroundTranscriptionInputDeviceLazyRoute
  '/_authenticated/playground/typography': typeof AuthenticatedPlaygroundTypographyLazyRoute
  '/_authenticated/playground/vlist-overlap': typeof AuthenticatedPlaygroundVlistOverlapLazyRoute
  '/_authenticated/playground/whats-new': typeof AuthenticatedPlaygroundWhatsNewLazyRoute
  '/_authenticated/playground/widgets': typeof AuthenticatedPlaygroundWidgetsLazyRoute
  '/_channels/channels/connect': typeof ChannelsChannelsConnectLazyRoute
  '/_channels/channels/integrations': typeof ChannelsChannelsIntegrationsLazyRoute
  '/_channels/channels/routines': typeof ChannelsChannelsRoutinesLazyRoute
  '/_channels/channels/settings': typeof ChannelsChannelsSettingsLazyRoute
  '/_authenticated/activity-timeline/': typeof AuthenticatedActivityTimelineIndexRoute
  '/_authenticated/arena/': typeof AuthenticatedArenaIndexRoute
  '/_authenticated/bird-game/': typeof AuthenticatedBirdGameIndexRoute
  '/_authenticated/channel-simulator/': typeof AuthenticatedChannelSimulatorIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/ck-debug/': typeof AuthenticatedCkDebugIndexRoute
  '/_authenticated/debug/': typeof AuthenticatedDebugIndexRoute
  '/_authenticated/echonotes/': typeof AuthenticatedEchonotesIndexRoute
  '/_authenticated/feed/': typeof AuthenticatedFeedIndexRoute
  '/_authenticated/ingestion/': typeof AuthenticatedIngestionIndexRoute
  '/_authenticated/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/_authenticated/journal/': typeof AuthenticatedJournalIndexRoute
  '/_authenticated/mcp-info/': typeof AuthenticatedMcpInfoIndexRoute
  '/_authenticated/meeting-debug/': typeof AuthenticatedMeetingDebugIndexRoute
  '/_authenticated/meetings/': typeof AuthenticatedMeetingsIndexRoute
  '/_authenticated/people-wiki/': typeof AuthenticatedPeopleWikiIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/routine-chats/': typeof AuthenticatedRoutineChatsIndexRoute
  '/_authenticated/routines/': typeof AuthenticatedRoutinesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/sprites/': typeof AuthenticatedSpritesIndexRoute
  '/_authenticated/summary-timeline/': typeof AuthenticatedSummaryTimelineIndexRoute
  '/_authenticated/welcome/': typeof AuthenticatedWelcomeIndexRoute
  '/_authenticated/world-model/': typeof AuthenticatedWorldModelIndexRoute
  '/_channels/channels/': typeof ChannelsChannelsIndexLazyRoute
  '/_authenticated/projects/$projectId_/shared/$itemType/$itemId': typeof AuthenticatedProjectsProjectIdSharedItemTypeItemIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/accessibility'
    | '/desktop-login'
    | '/login'
    | '/onboarding'
    | '/onboarding-new'
    | '/shared-arena'
    | '/upgrade'
    | '/verify-email'
    | '/link'
    | '/meetings'
    | '/channels'
    | '/artifact/$token'
    | '/auth-callback/desktop'
    | '/change-email/verify'
    | '/channels/sign-in'
    | '/error/session-expired'
    | '/f/$token'
    | '/shared-chat/$id'
    | '/shared-meeting/$id'
    | '/team/join'
    | '/wrapped/$shareId'
    | '/account/delete'
    | '/account/support'
    | '/'
    | '/auth-callback'
    | '/agents/attention'
    | '/agents/new-task'
    | '/arena/$arenaId'
    | '/chats/$chatId'
    | '/chats/all'
    | '/journal/$journalId'
    | '/meetings/$meetingId'
    | '/p/$pluginId'
    | '/people-wiki/$personId'
    | '/playground/action-cards-v2'
    | '/playground/canvas'
    | '/projects/$projectId'
    | '/reports/$routineId'
    | '/routine-chats/$routineId'
    | '/routines/$routineId'
    | '/settings/$section'
    | '/sprites/$spriteId'
    | '/browser-saved-credential/$requestId'
    | '/browser-sign-in/$signInSessionId'
    | '/channels/onboarding'
    | '/channels/upgrade'
    | '/projects/join/$token'
    | '/playground/artifacts'
    | '/playground/ask-user-questions'
    | '/playground/banner'
    | '/playground/bird-thinking-states'
    | '/playground/buttons'
    | '/playground/calendar'
    | '/playground/colors'
    | '/playground/editable-tables'
    | '/playground/editor'
    | '/playground/editor-find-isolation'
    | '/playground/editor-preview-parity'
    | '/playground/empty-states'
    | '/playground/fast-scroll-bar'
    | '/playground/find'
    | '/playground/icons'
    | '/playground/live-region'
    | '/playground/markdown-editor'
    | '/playground/meetings-empty-state'
    | '/playground/notifications'
    | '/playground/reasoning'
    | '/playground/send-draft-card'
    | '/playground/smoothdown'
    | '/playground/sounds'
    | '/playground/subscription'
    | '/playground/team-plan'
    | '/playground/toasts'
    | '/playground/transcript-streaming'
    | '/playground/transcription-input-device'
    | '/playground/typography'
    | '/playground/vlist-overlap'
    | '/playground/whats-new'
    | '/playground/widgets'
    | '/channels/connect'
    | '/channels/integrations'
    | '/channels/routines'
    | '/channels/settings'
    | '/activity-timeline'
    | '/arena'
    | '/bird-game'
    | '/channel-simulator'
    | '/chats'
    | '/ck-debug'
    | '/debug'
    | '/echonotes'
    | '/feed'
    | '/ingestion'
    | '/integrations'
    | '/journal'
    | '/mcp-info'
    | '/meeting-debug'
    | '/meetings/'
    | '/people-wiki'
    | '/projects'
    | '/reports'
    | '/routine-chats'
    | '/routines'
    | '/settings'
    | '/sprites'
    | '/summary-timeline'
    | '/welcome'
    | '/world-model'
    | '/channels/'
    | '/projects/$projectId/shared/$itemType/$itemId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accessibility'
    | '/desktop-login'
    | '/login'
    | '/onboarding'
    | '/onboarding-new'
    | '/shared-arena'
    | '/upgrade'
    | '/verify-email'
    | '/link'
    | '/artifact/$token'
    | '/auth-callback/desktop'
    | '/change-email/verify'
    | '/channels/sign-in'
    | '/error/session-expired'
    | '/f/$token'
    | '/shared-chat/$id'
    | '/shared-meeting/$id'
    | '/team/join'
    | '/wrapped/$shareId'
    | '/account/delete'
    | '/account/support'
    | '/'
    | '/auth-callback'
    | '/agents/attention'
    | '/agents/new-task'
    | '/arena/$arenaId'
    | '/chats/$chatId'
    | '/chats/all'
    | '/journal/$journalId'
    | '/meetings/$meetingId'
    | '/p/$pluginId'
    | '/people-wiki/$personId'
    | '/playground/action-cards-v2'
    | '/playground/canvas'
    | '/projects/$projectId'
    | '/reports/$routineId'
    | '/routine-chats/$routineId'
    | '/routines/$routineId'
    | '/settings/$section'
    | '/sprites/$spriteId'
    | '/browser-saved-credential/$requestId'
    | '/browser-sign-in/$signInSessionId'
    | '/channels/onboarding'
    | '/channels/upgrade'
    | '/projects/join/$token'
    | '/playground/artifacts'
    | '/playground/ask-user-questions'
    | '/playground/banner'
    | '/playground/bird-thinking-states'
    | '/playground/buttons'
    | '/playground/calendar'
    | '/playground/colors'
    | '/playground/editable-tables'
    | '/playground/editor'
    | '/playground/editor-find-isolation'
    | '/playground/editor-preview-parity'
    | '/playground/empty-states'
    | '/playground/fast-scroll-bar'
    | '/playground/find'
    | '/playground/icons'
    | '/playground/live-region'
    | '/playground/markdown-editor'
    | '/playground/meetings-empty-state'
    | '/playground/notifications'
    | '/playground/reasoning'
    | '/playground/send-draft-card'
    | '/playground/smoothdown'
    | '/playground/sounds'
    | '/playground/subscription'
    | '/playground/team-plan'
    | '/playground/toasts'
    | '/playground/transcript-streaming'
    | '/playground/transcription-input-device'
    | '/playground/typography'
    | '/playground/vlist-overlap'
    | '/playground/whats-new'
    | '/playground/widgets'
    | '/channels/connect'
    | '/channels/integrations'
    | '/channels/routines'
    | '/channels/settings'
    | '/activity-timeline'
    | '/arena'
    | '/bird-game'
    | '/channel-simulator'
    | '/chats'
    | '/ck-debug'
    | '/debug'
    | '/echonotes'
    | '/feed'
    | '/ingestion'
    | '/integrations'
    | '/journal'
    | '/mcp-info'
    | '/meeting-debug'
    | '/meetings'
    | '/people-wiki'
    | '/projects'
    | '/reports'
    | '/routine-chats'
    | '/routines'
    | '/settings'
    | '/sprites'
    | '/summary-timeline'
    | '/welcome'
    | '/world-model'
    | '/channels'
    | '/projects/$projectId/shared/$itemType/$itemId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_browser-request'
    | '/_channels'
    | '/accessibility'
    | '/desktop-login'
    | '/login'
    | '/onboarding'
    | '/onboarding-new'
    | '/shared-arena'
    | '/upgrade'
    | '/verify-email'
    | '/link'
    | '/_authenticated/meetings'
    | '/_channels/channels'
    | '/artifact/$token'
    | '/auth-callback/desktop'
    | '/change-email/verify'
    | '/channels/sign-in'
    | '/error/session-expired'
    | '/f/$token'
    | '/shared-chat/$id'
    | '/shared-meeting/$id'
    | '/team/join'
    | '/wrapped/$shareId'
    | '/account/delete'
    | '/account/support'
    | '/_authenticated/'
    | '/auth-callback/'
    | '/_authenticated/agents/attention'
    | '/_authenticated/agents/new-task'
    | '/_authenticated/arena/$arenaId'
    | '/_authenticated/chats/$chatId'
    | '/_authenticated/chats/all'
    | '/_authenticated/journal/$journalId'
    | '/_authenticated/meetings/$meetingId'
    | '/_authenticated/p/$pluginId'
    | '/_authenticated/people-wiki/$personId'
    | '/_authenticated/playground/action-cards-v2'
    | '/_authenticated/playground/canvas'
    | '/_authenticated/projects/$projectId'
    | '/_authenticated/reports/$routineId'
    | '/_authenticated/routine-chats/$routineId'
    | '/_authenticated/routines/$routineId'
    | '/_authenticated/settings/$section'
    | '/_authenticated/sprites/$spriteId'
    | '/_browser-request/browser-saved-credential/$requestId'
    | '/_browser-request/browser-sign-in/$signInSessionId'
    | '/_channels/channels/onboarding'
    | '/_channels/channels/upgrade'
    | '/projects/join/$token'
    | '/_authenticated/playground/artifacts'
    | '/_authenticated/playground/ask-user-questions'
    | '/_authenticated/playground/banner'
    | '/_authenticated/playground/bird-thinking-states'
    | '/_authenticated/playground/buttons'
    | '/_authenticated/playground/calendar'
    | '/_authenticated/playground/colors'
    | '/_authenticated/playground/editable-tables'
    | '/_authenticated/playground/editor'
    | '/_authenticated/playground/editor-find-isolation'
    | '/_authenticated/playground/editor-preview-parity'
    | '/_authenticated/playground/empty-states'
    | '/_authenticated/playground/fast-scroll-bar'
    | '/_authenticated/playground/find'
    | '/_authenticated/playground/icons'
    | '/_authenticated/playground/live-region'
    | '/_authenticated/playground/markdown-editor'
    | '/_authenticated/playground/meetings-empty-state'
    | '/_authenticated/playground/notifications'
    | '/_authenticated/playground/reasoning'
    | '/_authenticated/playground/send-draft-card'
    | '/_authenticated/playground/smoothdown'
    | '/_authenticated/playground/sounds'
    | '/_authenticated/playground/subscription'
    | '/_authenticated/playground/team-plan'
    | '/_authenticated/playground/toasts'
    | '/_authenticated/playground/transcript-streaming'
    | '/_authenticated/playground/transcription-input-device'
    | '/_authenticated/playground/typography'
    | '/_authenticated/playground/vlist-overlap'
    | '/_authenticated/playground/whats-new'
    | '/_authenticated/playground/widgets'
    | '/_channels/channels/connect'
    | '/_channels/channels/integrations'
    | '/_channels/channels/routines'
    | '/_channels/channels/settings'
    | '/_authenticated/activity-timeline/'
    | '/_authenticated/arena/'
    | '/_authenticated/bird-game/'
    | '/_authenticated/channel-simulator/'
    | '/_authenticated/chats/'
    | '/_authenticated/ck-debug/'
    | '/_authenticated/debug/'
    | '/_authenticated/echonotes/'
    | '/_authenticated/feed/'
    | '/_authenticated/ingestion/'
    | '/_authenticated/integrations/'
    | '/_authenticated/journal/'
    | '/_authenticated/mcp-info/'
    | '/_authenticated/meeting-debug/'
    | '/_authenticated/meetings/'
    | '/_authenticated/people-wiki/'
    | '/_authenticated/projects/'
    | '/_authenticated/reports/'
    | '/_authenticated/routine-chats/'
    | '/_authenticated/routines/'
    | '/_authenticated/settings/'
    | '/_authenticated/sprites/'
    | '/_authenticated/summary-timeline/'
    | '/_authenticated/welcome/'
    | '/_authenticated/world-model/'
    | '/_channels/channels/'
    | '/_authenticated/projects/$projectId_/shared/$itemType/$itemId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  BrowserRequestRoute: typeof BrowserRequestRouteWithChildren
  ChannelsRoute: typeof ChannelsRouteWithChildren
  AccessibilityRoute: typeof AccessibilityRoute
  DesktopLoginRoute: typeof DesktopLoginRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  OnboardingNewRoute: typeof OnboardingNewRoute
  SharedArenaRoute: typeof SharedArenaRoute
  UpgradeRoute: typeof UpgradeRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  LinkLazyRoute: typeof LinkLazyRoute
  ArtifactTokenRoute: typeof ArtifactTokenRoute
  AuthCallbackDesktopRoute: typeof AuthCallbackDesktopRoute
  ChangeEmailVerifyRoute: typeof ChangeEmailVerifyRoute
  ChannelsSignInRoute: typeof ChannelsSignInRoute
  ErrorSessionExpiredRoute: typeof ErrorSessionExpiredRoute
  FTokenRoute: typeof FTokenRoute
  SharedChatIdRoute: typeof SharedChatIdRoute
  SharedMeetingIdRoute: typeof SharedMeetingIdRoute
  TeamJoinRoute: typeof TeamJoinRoute
  WrappedShareIdRoute: typeof WrappedShareIdRoute
  AccountDeleteLazyRoute: typeof AccountDeleteLazyRoute
  AccountSupportLazyRoute: typeof AccountSupportLazyRoute
  AuthCallbackIndexRoute: typeof AuthCallbackIndexRoute
  ProjectsJoinTokenRoute: typeof ProjectsJoinTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/link': {
      id: '/link'
      path: '/link'
      fullPath: '/link'
      preLoaderRoute: typeof LinkLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade': {
      id: '/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof UpgradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared-arena': {
      id: '/shared-arena'
      path: '/shared-arena'
      fullPath: '/shared-arena'
      preLoaderRoute: typeof SharedArenaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding-new': {
      id: '/onboarding-new'
      path: '/onboarding-new'
      fullPath: '/onboarding-new'
      preLoaderRoute: typeof OnboardingNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desktop-login': {
      id: '/desktop-login'
      path: '/desktop-login'
      fullPath: '/desktop-login'
      preLoaderRoute: typeof DesktopLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accessibility': {
      id: '/accessibility'
      path: '/accessibility'
      fullPath: '/accessibility'
      preLoaderRoute: typeof AccessibilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_channels': {
      id: '/_channels'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ChannelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_browser-request': {
      id: '/_browser-request'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof BrowserRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-callback/': {
      id: '/auth-callback/'
      path: '/auth-callback'
      fullPath: '/auth-callback'
      preLoaderRoute: typeof AuthCallbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/account/support': {
      id: '/account/support'
      path: '/account/support'
      fullPath: '/account/support'
      preLoaderRoute: typeof AccountSupportLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/delete': {
      id: '/account/delete'
      path: '/account/delete'
      fullPath: '/account/delete'
      preLoaderRoute: typeof AccountDeleteLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wrapped/$shareId': {
      id: '/wrapped/$shareId'
      path: '/wrapped/$shareId'
      fullPath: '/wrapped/$shareId'
      preLoaderRoute: typeof WrappedShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/join': {
      id: '/team/join'
      path: '/team/join'
      fullPath: '/team/join'
      preLoaderRoute: typeof TeamJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared-meeting/$id': {
      id: '/shared-meeting/$id'
      path: '/shared-meeting/$id'
      fullPath: '/shared-meeting/$id'
      preLoaderRoute: typeof SharedMeetingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared-chat/$id': {
      id: '/shared-chat/$id'
      path: '/shared-chat/$id'
      fullPath: '/shared-chat/$id'
      preLoaderRoute: typeof SharedChatIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/f/$token': {
      id: '/f/$token'
      path: '/f/$token'
      fullPath: '/f/$token'
      preLoaderRoute: typeof FTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/session-expired': {
      id: '/error/session-expired'
      path: '/error/session-expired'
      fullPath: '/error/session-expired'
      preLoaderRoute: typeof ErrorSessionExpiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/channels/sign-in': {
      id: '/channels/sign-in'
      path: '/channels/sign-in'
      fullPath: '/channels/sign-in'
      preLoaderRoute: typeof ChannelsSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-email/verify': {
      id: '/change-email/verify'
      path: '/change-email/verify'
      fullPath: '/change-email/verify'
      preLoaderRoute: typeof ChangeEmailVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-callback/desktop': {
      id: '/auth-callback/desktop'
      path: '/auth-callback/desktop'
      fullPath: '/auth-callback/desktop'
      preLoaderRoute: typeof AuthCallbackDesktopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artifact/$token': {
      id: '/artifact/$token'
      path: '/artifact/$token'
      fullPath: '/artifact/$token'
      preLoaderRoute: typeof ArtifactTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_channels/channels': {
      id: '/_channels/channels'
      path: '/channels'
      fullPath: '/channels'
      preLoaderRoute: typeof ChannelsChannelsRouteImport
      parentRoute: typeof ChannelsRoute
    }
    '/_authenticated/meetings': {
      id: '/_authenticated/meetings'
      path: '/meetings'
      fullPath: '/meetings'
      preLoaderRoute: typeof AuthenticatedMeetingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_channels/channels/': {
      id: '/_channels/channels/'
      path: '/'
      fullPath: '/channels/'
      preLoaderRoute: typeof ChannelsChannelsIndexLazyRouteImport
      parentRoute: typeof ChannelsChannelsRoute
    }
    '/_authenticated/world-model/': {
      id: '/_authenticated/world-model/'
      path: '/world-model'
      fullPath: '/world-model'
      preLoaderRoute: typeof AuthenticatedWorldModelIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/welcome/': {
      id: '/_authenticated/welcome/'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthenticatedWelcomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/summary-timeline/': {
      id: '/_authenticated/summary-timeline/'
      path: '/summary-timeline'
      fullPath: '/summary-timeline'
      preLoaderRoute: typeof AuthenticatedSummaryTimelineIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sprites/': {
      id: '/_authenticated/sprites/'
      path: '/sprites'
      fullPath: '/sprites'
      preLoaderRoute: typeof AuthenticatedSpritesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routines/': {
      id: '/_authenticated/routines/'
      path: '/routines'
      fullPath: '/routines'
      preLoaderRoute: typeof AuthenticatedRoutinesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routine-chats/': {
      id: '/_authenticated/routine-chats/'
      path: '/routine-chats'
      fullPath: '/routine-chats'
      preLoaderRoute: typeof AuthenticatedRoutineChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/people-wiki/': {
      id: '/_authenticated/people-wiki/'
      path: '/people-wiki'
      fullPath: '/people-wiki'
      preLoaderRoute: typeof AuthenticatedPeopleWikiIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meetings/': {
      id: '/_authenticated/meetings/'
      path: '/'
      fullPath: '/meetings/'
      preLoaderRoute: typeof AuthenticatedMeetingsIndexRouteImport
      parentRoute: typeof AuthenticatedMeetingsRoute
    }
    '/_authenticated/meeting-debug/': {
      id: '/_authenticated/meeting-debug/'
      path: '/meeting-debug'
      fullPath: '/meeting-debug'
      preLoaderRoute: typeof AuthenticatedMeetingDebugIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mcp-info/': {
      id: '/_authenticated/mcp-info/'
      path: '/mcp-info'
      fullPath: '/mcp-info'
      preLoaderRoute: typeof AuthenticatedMcpInfoIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/journal/': {
      id: '/_authenticated/journal/'
      path: '/journal'
      fullPath: '/journal'
      preLoaderRoute: typeof AuthenticatedJournalIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations/': {
      id: '/_authenticated/integrations/'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthenticatedIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ingestion/': {
      id: '/_authenticated/ingestion/'
      path: '/ingestion'
      fullPath: '/ingestion'
      preLoaderRoute: typeof AuthenticatedIngestionIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feed/': {
      id: '/_authenticated/feed/'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof AuthenticatedFeedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/echonotes/': {
      id: '/_authenticated/echonotes/'
      path: '/echonotes'
      fullPath: '/echonotes'
      preLoaderRoute: typeof AuthenticatedEchonotesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/debug/': {
      id: '/_authenticated/debug/'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof AuthenticatedDebugIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ck-debug/': {
      id: '/_authenticated/ck-debug/'
      path: '/ck-debug'
      fullPath: '/ck-debug'
      preLoaderRoute: typeof AuthenticatedCkDebugIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/channel-simulator/': {
      id: '/_authenticated/channel-simulator/'
      path: '/channel-simulator'
      fullPath: '/channel-simulator'
      preLoaderRoute: typeof AuthenticatedChannelSimulatorIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bird-game/': {
      id: '/_authenticated/bird-game/'
      path: '/bird-game'
      fullPath: '/bird-game'
      preLoaderRoute: typeof AuthenticatedBirdGameIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/arena/': {
      id: '/_authenticated/arena/'
      path: '/arena'
      fullPath: '/arena'
      preLoaderRoute: typeof AuthenticatedArenaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity-timeline/': {
      id: '/_authenticated/activity-timeline/'
      path: '/activity-timeline'
      fullPath: '/activity-timeline'
      preLoaderRoute: typeof AuthenticatedActivityTimelineIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_channels/channels/settings': {
      id: '/_channels/channels/settings'
      path: '/settings'
      fullPath: '/channels/settings'
      preLoaderRoute: typeof ChannelsChannelsSettingsLazyRouteImport
      parentRoute: typeof ChannelsChannelsRoute
    }
    '/_channels/channels/routines': {
      id: '/_channels/channels/routines'
      path: '/routines'
      fullPath: '/channels/routines'
      preLoaderRoute: typeof ChannelsChannelsRoutinesLazyRouteImport
      parentRoute: typeof ChannelsChannelsRoute
    }
    '/_channels/channels/integrations': {
      id: '/_channels/channels/integrations'
      path: '/integrations'
      fullPath: '/channels/integrations'
      preLoaderRoute: typeof ChannelsChannelsIntegrationsLazyRouteImport
      parentRoute: typeof ChannelsChannelsRoute
    }
    '/_channels/channels/connect': {
      id: '/_channels/channels/connect'
      path: '/connect'
      fullPath: '/channels/connect'
      preLoaderRoute: typeof ChannelsChannelsConnectLazyRouteImport
      parentRoute: typeof ChannelsChannelsRoute
    }
    '/_authenticated/playground/widgets': {
      id: '/_authenticated/playground/widgets'
      path: '/playground/widgets'
      fullPath: '/playground/widgets'
      preLoaderRoute: typeof AuthenticatedPlaygroundWidgetsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/whats-new': {
      id: '/_authenticated/playground/whats-new'
      path: '/playground/whats-new'
      fullPath: '/playground/whats-new'
      preLoaderRoute: typeof AuthenticatedPlaygroundWhatsNewLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/vlist-overlap': {
      id: '/_authenticated/playground/vlist-overlap'
      path: '/playground/vlist-overlap'
      fullPath: '/playground/vlist-overlap'
      preLoaderRoute: typeof AuthenticatedPlaygroundVlistOverlapLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/typography': {
      id: '/_authenticated/playground/typography'
      path: '/playground/typography'
      fullPath: '/playground/typography'
      preLoaderRoute: typeof AuthenticatedPlaygroundTypographyLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/transcription-input-device': {
      id: '/_authenticated/playground/transcription-input-device'
      path: '/playground/transcription-input-device'
      fullPath: '/playground/transcription-input-device'
      preLoaderRoute: typeof AuthenticatedPlaygroundTranscriptionInputDeviceLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/transcript-streaming': {
      id: '/_authenticated/playground/transcript-streaming'
      path: '/playground/transcript-streaming'
      fullPath: '/playground/transcript-streaming'
      preLoaderRoute: typeof AuthenticatedPlaygroundTranscriptStreamingLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/toasts': {
      id: '/_authenticated/playground/toasts'
      path: '/playground/toasts'
      fullPath: '/playground/toasts'
      preLoaderRoute: typeof AuthenticatedPlaygroundToastsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/team-plan': {
      id: '/_authenticated/playground/team-plan'
      path: '/playground/team-plan'
      fullPath: '/playground/team-plan'
      preLoaderRoute: typeof AuthenticatedPlaygroundTeamPlanLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/subscription': {
      id: '/_authenticated/playground/subscription'
      path: '/playground/subscription'
      fullPath: '/playground/subscription'
      preLoaderRoute: typeof AuthenticatedPlaygroundSubscriptionLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/sounds': {
      id: '/_authenticated/playground/sounds'
      path: '/playground/sounds'
      fullPath: '/playground/sounds'
      preLoaderRoute: typeof AuthenticatedPlaygroundSoundsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/smoothdown': {
      id: '/_authenticated/playground/smoothdown'
      path: '/playground/smoothdown'
      fullPath: '/playground/smoothdown'
      preLoaderRoute: typeof AuthenticatedPlaygroundSmoothdownLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/send-draft-card': {
      id: '/_authenticated/playground/send-draft-card'
      path: '/playground/send-draft-card'
      fullPath: '/playground/send-draft-card'
      preLoaderRoute: typeof AuthenticatedPlaygroundSendDraftCardLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/reasoning': {
      id: '/_authenticated/playground/reasoning'
      path: '/playground/reasoning'
      fullPath: '/playground/reasoning'
      preLoaderRoute: typeof AuthenticatedPlaygroundReasoningLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/notifications': {
      id: '/_authenticated/playground/notifications'
      path: '/playground/notifications'
      fullPath: '/playground/notifications'
      preLoaderRoute: typeof AuthenticatedPlaygroundNotificationsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/meetings-empty-state': {
      id: '/_authenticated/playground/meetings-empty-state'
      path: '/playground/meetings-empty-state'
      fullPath: '/playground/meetings-empty-state'
      preLoaderRoute: typeof AuthenticatedPlaygroundMeetingsEmptyStateLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/markdown-editor': {
      id: '/_authenticated/playground/markdown-editor'
      path: '/playground/markdown-editor'
      fullPath: '/playground/markdown-editor'
      preLoaderRoute: typeof AuthenticatedPlaygroundMarkdownEditorLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/live-region': {
      id: '/_authenticated/playground/live-region'
      path: '/playground/live-region'
      fullPath: '/playground/live-region'
      preLoaderRoute: typeof AuthenticatedPlaygroundLiveRegionLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/icons': {
      id: '/_authenticated/playground/icons'
      path: '/playground/icons'
      fullPath: '/playground/icons'
      preLoaderRoute: typeof AuthenticatedPlaygroundIconsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/find': {
      id: '/_authenticated/playground/find'
      path: '/playground/find'
      fullPath: '/playground/find'
      preLoaderRoute: typeof AuthenticatedPlaygroundFindLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/fast-scroll-bar': {
      id: '/_authenticated/playground/fast-scroll-bar'
      path: '/playground/fast-scroll-bar'
      fullPath: '/playground/fast-scroll-bar'
      preLoaderRoute: typeof AuthenticatedPlaygroundFastScrollBarLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/empty-states': {
      id: '/_authenticated/playground/empty-states'
      path: '/playground/empty-states'
      fullPath: '/playground/empty-states'
      preLoaderRoute: typeof AuthenticatedPlaygroundEmptyStatesLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/editor-preview-parity': {
      id: '/_authenticated/playground/editor-preview-parity'
      path: '/playground/editor-preview-parity'
      fullPath: '/playground/editor-preview-parity'
      preLoaderRoute: typeof AuthenticatedPlaygroundEditorPreviewParityLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/editor-find-isolation': {
      id: '/_authenticated/playground/editor-find-isolation'
      path: '/playground/editor-find-isolation'
      fullPath: '/playground/editor-find-isolation'
      preLoaderRoute: typeof AuthenticatedPlaygroundEditorFindIsolationLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/editor': {
      id: '/_authenticated/playground/editor'
      path: '/playground/editor'
      fullPath: '/playground/editor'
      preLoaderRoute: typeof AuthenticatedPlaygroundEditorLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/editable-tables': {
      id: '/_authenticated/playground/editable-tables'
      path: '/playground/editable-tables'
      fullPath: '/playground/editable-tables'
      preLoaderRoute: typeof AuthenticatedPlaygroundEditableTablesLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/colors': {
      id: '/_authenticated/playground/colors'
      path: '/playground/colors'
      fullPath: '/playground/colors'
      preLoaderRoute: typeof AuthenticatedPlaygroundColorsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/calendar': {
      id: '/_authenticated/playground/calendar'
      path: '/playground/calendar'
      fullPath: '/playground/calendar'
      preLoaderRoute: typeof AuthenticatedPlaygroundCalendarLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/buttons': {
      id: '/_authenticated/playground/buttons'
      path: '/playground/buttons'
      fullPath: '/playground/buttons'
      preLoaderRoute: typeof AuthenticatedPlaygroundButtonsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/bird-thinking-states': {
      id: '/_authenticated/playground/bird-thinking-states'
      path: '/playground/bird-thinking-states'
      fullPath: '/playground/bird-thinking-states'
      preLoaderRoute: typeof AuthenticatedPlaygroundBirdThinkingStatesLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/banner': {
      id: '/_authenticated/playground/banner'
      path: '/playground/banner'
      fullPath: '/playground/banner'
      preLoaderRoute: typeof AuthenticatedPlaygroundBannerLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/ask-user-questions': {
      id: '/_authenticated/playground/ask-user-questions'
      path: '/playground/ask-user-questions'
      fullPath: '/playground/ask-user-questions'
      preLoaderRoute: typeof AuthenticatedPlaygroundAskUserQuestionsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/artifacts': {
      id: '/_authenticated/playground/artifacts'
      path: '/playground/artifacts'
      fullPath: '/playground/artifacts'
      preLoaderRoute: typeof AuthenticatedPlaygroundArtifactsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/projects/join/$token': {
      id: '/projects/join/$token'
      path: '/projects/join/$token'
      fullPath: '/projects/join/$token'
      preLoaderRoute: typeof ProjectsJoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_channels/channels/upgrade': {
      id: '/_channels/channels/upgrade'
      path: '/upgrade'
      fullPath: '/channels/upgrade'
      preLoaderRoute: typeof ChannelsChannelsUpgradeRouteImport
      parentRoute: typeof ChannelsChannelsRoute
    }
    '/_channels/channels/onboarding': {
      id: '/_channels/channels/onboarding'
      path: '/onboarding'
      fullPath: '/channels/onboarding'
      preLoaderRoute: typeof ChannelsChannelsOnboardingRouteImport
      parentRoute: typeof ChannelsChannelsRoute
    }
    '/_browser-request/browser-sign-in/$signInSessionId': {
      id: '/_browser-request/browser-sign-in/$signInSessionId'
      path: '/browser-sign-in/$signInSessionId'
      fullPath: '/browser-sign-in/$signInSessionId'
      preLoaderRoute: typeof BrowserRequestBrowserSignInSignInSessionIdRouteImport
      parentRoute: typeof BrowserRequestRoute
    }
    '/_browser-request/browser-saved-credential/$requestId': {
      id: '/_browser-request/browser-saved-credential/$requestId'
      path: '/browser-saved-credential/$requestId'
      fullPath: '/browser-saved-credential/$requestId'
      preLoaderRoute: typeof BrowserRequestBrowserSavedCredentialRequestIdRouteImport
      parentRoute: typeof BrowserRequestRoute
    }
    '/_authenticated/sprites/$spriteId': {
      id: '/_authenticated/sprites/$spriteId'
      path: '/sprites/$spriteId'
      fullPath: '/sprites/$spriteId'
      preLoaderRoute: typeof AuthenticatedSpritesSpriteIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/$section': {
      id: '/_authenticated/settings/$section'
      path: '/settings/$section'
      fullPath: '/settings/$section'
      preLoaderRoute: typeof AuthenticatedSettingsSectionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routines/$routineId': {
      id: '/_authenticated/routines/$routineId'
      path: '/routines/$routineId'
      fullPath: '/routines/$routineId'
      preLoaderRoute: typeof AuthenticatedRoutinesRoutineIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routine-chats/$routineId': {
      id: '/_authenticated/routine-chats/$routineId'
      path: '/routine-chats/$routineId'
      fullPath: '/routine-chats/$routineId'
      preLoaderRoute: typeof AuthenticatedRoutineChatsRoutineIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/$routineId': {
      id: '/_authenticated/reports/$routineId'
      path: '/reports/$routineId'
      fullPath: '/reports/$routineId'
      preLoaderRoute: typeof AuthenticatedReportsRoutineIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId': {
      id: '/_authenticated/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/canvas': {
      id: '/_authenticated/playground/canvas'
      path: '/playground/canvas'
      fullPath: '/playground/canvas'
      preLoaderRoute: typeof AuthenticatedPlaygroundCanvasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground/action-cards-v2': {
      id: '/_authenticated/playground/action-cards-v2'
      path: '/playground/action-cards-v2'
      fullPath: '/playground/action-cards-v2'
      preLoaderRoute: typeof AuthenticatedPlaygroundActionCardsV2RouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/people-wiki/$personId': {
      id: '/_authenticated/people-wiki/$personId'
      path: '/people-wiki/$personId'
      fullPath: '/people-wiki/$personId'
      preLoaderRoute: typeof AuthenticatedPeopleWikiPersonIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/p/$pluginId': {
      id: '/_authenticated/p/$pluginId'
      path: '/p/$pluginId'
      fullPath: '/p/$pluginId'
      preLoaderRoute: typeof AuthenticatedPPluginIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meetings/$meetingId': {
      id: '/_authenticated/meetings/$meetingId'
      path: '/$meetingId'
      fullPath: '/meetings/$meetingId'
      preLoaderRoute: typeof AuthenticatedMeetingsMeetingIdRouteImport
      parentRoute: typeof AuthenticatedMeetingsRoute
    }
    '/_authenticated/journal/$journalId': {
      id: '/_authenticated/journal/$journalId'
      path: '/journal/$journalId'
      fullPath: '/journal/$journalId'
      preLoaderRoute: typeof AuthenticatedJournalJournalIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chats/all': {
      id: '/_authenticated/chats/all'
      path: '/chats/all'
      fullPath: '/chats/all'
      preLoaderRoute: typeof AuthenticatedChatsAllRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chats/$chatId': {
      id: '/_authenticated/chats/$chatId'
      path: '/chats/$chatId'
      fullPath: '/chats/$chatId'
      preLoaderRoute: typeof AuthenticatedChatsChatIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/arena/$arenaId': {
      id: '/_authenticated/arena/$arenaId'
      path: '/arena/$arenaId'
      fullPath: '/arena/$arenaId'
      preLoaderRoute: typeof AuthenticatedArenaArenaIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agents/new-task': {
      id: '/_authenticated/agents/new-task'
      path: '/agents/new-task'
      fullPath: '/agents/new-task'
      preLoaderRoute: typeof AuthenticatedAgentsNewTaskRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agents/attention': {
      id: '/_authenticated/agents/attention'
      path: '/agents/attention'
      fullPath: '/agents/attention'
      preLoaderRoute: typeof AuthenticatedAgentsAttentionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId_/shared/$itemType/$itemId': {
      id: '/_authenticated/projects/$projectId_/shared/$itemType/$itemId'
      path: '/projects/$projectId/shared/$itemType/$itemId'
      fullPath: '/projects/$projectId/shared/$itemType/$itemId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSharedItemTypeItemIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedMeetingsRouteChildren {
  AuthenticatedMeetingsMeetingIdRoute: typeof AuthenticatedMeetingsMeetingIdRoute
  AuthenticatedMeetingsIndexRoute: typeof AuthenticatedMeetingsIndexRoute
}

const AuthenticatedMeetingsRouteChildren: AuthenticatedMeetingsRouteChildren = {
  AuthenticatedMeetingsMeetingIdRoute: AuthenticatedMeetingsMeetingIdRoute,
  AuthenticatedMeetingsIndexRoute: AuthenticatedMeetingsIndexRoute,
}

const AuthenticatedMeetingsRouteWithChildren =
  AuthenticatedMeetingsRoute._addFileChildren(
    AuthenticatedMeetingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedMeetingsRoute: typeof AuthenticatedMeetingsRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAgentsAttentionRoute: typeof AuthenticatedAgentsAttentionRoute
  AuthenticatedAgentsNewTaskRoute: typeof AuthenticatedAgentsNewTaskRoute
  AuthenticatedArenaArenaIdRoute: typeof AuthenticatedArenaArenaIdRoute
  AuthenticatedChatsChatIdRoute: typeof AuthenticatedChatsChatIdRoute
  AuthenticatedChatsAllRoute: typeof AuthenticatedChatsAllRoute
  AuthenticatedJournalJournalIdRoute: typeof AuthenticatedJournalJournalIdRoute
  AuthenticatedPPluginIdRoute: typeof AuthenticatedPPluginIdRoute
  AuthenticatedPeopleWikiPersonIdRoute: typeof AuthenticatedPeopleWikiPersonIdRoute
  AuthenticatedPlaygroundActionCardsV2Route: typeof AuthenticatedPlaygroundActionCardsV2Route
  AuthenticatedPlaygroundCanvasRoute: typeof AuthenticatedPlaygroundCanvasRoute
  AuthenticatedProjectsProjectIdRoute: typeof AuthenticatedProjectsProjectIdRoute
  AuthenticatedReportsRoutineIdRoute: typeof AuthenticatedReportsRoutineIdRoute
  AuthenticatedRoutineChatsRoutineIdRoute: typeof AuthenticatedRoutineChatsRoutineIdRoute
  AuthenticatedRoutinesRoutineIdRoute: typeof AuthenticatedRoutinesRoutineIdRoute
  AuthenticatedSettingsSectionRoute: typeof AuthenticatedSettingsSectionRoute
  AuthenticatedSpritesSpriteIdRoute: typeof AuthenticatedSpritesSpriteIdRoute
  AuthenticatedPlaygroundArtifactsLazyRoute: typeof AuthenticatedPlaygroundArtifactsLazyRoute
  AuthenticatedPlaygroundAskUserQuestionsLazyRoute: typeof AuthenticatedPlaygroundAskUserQuestionsLazyRoute
  AuthenticatedPlaygroundBannerLazyRoute: typeof AuthenticatedPlaygroundBannerLazyRoute
  AuthenticatedPlaygroundBirdThinkingStatesLazyRoute: typeof AuthenticatedPlaygroundBirdThinkingStatesLazyRoute
  AuthenticatedPlaygroundButtonsLazyRoute: typeof AuthenticatedPlaygroundButtonsLazyRoute
  AuthenticatedPlaygroundCalendarLazyRoute: typeof AuthenticatedPlaygroundCalendarLazyRoute
  AuthenticatedPlaygroundColorsLazyRoute: typeof AuthenticatedPlaygroundColorsLazyRoute
  AuthenticatedPlaygroundEditableTablesLazyRoute: typeof AuthenticatedPlaygroundEditableTablesLazyRoute
  AuthenticatedPlaygroundEditorLazyRoute: typeof AuthenticatedPlaygroundEditorLazyRoute
  AuthenticatedPlaygroundEditorFindIsolationLazyRoute: typeof AuthenticatedPlaygroundEditorFindIsolationLazyRoute
  AuthenticatedPlaygroundEditorPreviewParityLazyRoute: typeof AuthenticatedPlaygroundEditorPreviewParityLazyRoute
  AuthenticatedPlaygroundEmptyStatesLazyRoute: typeof AuthenticatedPlaygroundEmptyStatesLazyRoute
  AuthenticatedPlaygroundFastScrollBarLazyRoute: typeof AuthenticatedPlaygroundFastScrollBarLazyRoute
  AuthenticatedPlaygroundFindLazyRoute: typeof AuthenticatedPlaygroundFindLazyRoute
  AuthenticatedPlaygroundIconsLazyRoute: typeof AuthenticatedPlaygroundIconsLazyRoute
  AuthenticatedPlaygroundLiveRegionLazyRoute: typeof AuthenticatedPlaygroundLiveRegionLazyRoute
  AuthenticatedPlaygroundMarkdownEditorLazyRoute: typeof AuthenticatedPlaygroundMarkdownEditorLazyRoute
  AuthenticatedPlaygroundMeetingsEmptyStateLazyRoute: typeof AuthenticatedPlaygroundMeetingsEmptyStateLazyRoute
  AuthenticatedPlaygroundNotificationsLazyRoute: typeof AuthenticatedPlaygroundNotificationsLazyRoute
  AuthenticatedPlaygroundReasoningLazyRoute: typeof AuthenticatedPlaygroundReasoningLazyRoute
  AuthenticatedPlaygroundSendDraftCardLazyRoute: typeof AuthenticatedPlaygroundSendDraftCardLazyRoute
  AuthenticatedPlaygroundSmoothdownLazyRoute: typeof AuthenticatedPlaygroundSmoothdownLazyRoute
  AuthenticatedPlaygroundSoundsLazyRoute: typeof AuthenticatedPlaygroundSoundsLazyRoute
  AuthenticatedPlaygroundSubscriptionLazyRoute: typeof AuthenticatedPlaygroundSubscriptionLazyRoute
  AuthenticatedPlaygroundTeamPlanLazyRoute: typeof AuthenticatedPlaygroundTeamPlanLazyRoute
  AuthenticatedPlaygroundToastsLazyRoute: typeof AuthenticatedPlaygroundToastsLazyRoute
  AuthenticatedPlaygroundTranscriptStreamingLazyRoute: typeof AuthenticatedPlaygroundTranscriptStreamingLazyRoute
  AuthenticatedPlaygroundTranscriptionInputDeviceLazyRoute: typeof AuthenticatedPlaygroundTranscriptionInputDeviceLazyRoute
  AuthenticatedPlaygroundTypographyLazyRoute: typeof AuthenticatedPlaygroundTypographyLazyRoute
  AuthenticatedPlaygroundVlistOverlapLazyRoute: typeof AuthenticatedPlaygroundVlistOverlapLazyRoute
  AuthenticatedPlaygroundWhatsNewLazyRoute: typeof AuthenticatedPlaygroundWhatsNewLazyRoute
  AuthenticatedPlaygroundWidgetsLazyRoute: typeof AuthenticatedPlaygroundWidgetsLazyRoute
  AuthenticatedActivityTimelineIndexRoute: typeof AuthenticatedActivityTimelineIndexRoute
  AuthenticatedArenaIndexRoute: typeof AuthenticatedArenaIndexRoute
  AuthenticatedBirdGameIndexRoute: typeof AuthenticatedBirdGameIndexRoute
  AuthenticatedChannelSimulatorIndexRoute: typeof AuthenticatedChannelSimulatorIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedCkDebugIndexRoute: typeof AuthenticatedCkDebugIndexRoute
  AuthenticatedDebugIndexRoute: typeof AuthenticatedDebugIndexRoute
  AuthenticatedEchonotesIndexRoute: typeof AuthenticatedEchonotesIndexRoute
  AuthenticatedFeedIndexRoute: typeof AuthenticatedFeedIndexRoute
  AuthenticatedIngestionIndexRoute: typeof AuthenticatedIngestionIndexRoute
  AuthenticatedIntegrationsIndexRoute: typeof AuthenticatedIntegrationsIndexRoute
  AuthenticatedJournalIndexRoute: typeof AuthenticatedJournalIndexRoute
  AuthenticatedMcpInfoIndexRoute: typeof AuthenticatedMcpInfoIndexRoute
  AuthenticatedMeetingDebugIndexRoute: typeof AuthenticatedMeetingDebugIndexRoute
  AuthenticatedPeopleWikiIndexRoute: typeof AuthenticatedPeopleWikiIndexRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
  AuthenticatedRoutineChatsIndexRoute: typeof AuthenticatedRoutineChatsIndexRoute
  AuthenticatedRoutinesIndexRoute: typeof AuthenticatedRoutinesIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSpritesIndexRoute: typeof AuthenticatedSpritesIndexRoute
  AuthenticatedSummaryTimelineIndexRoute: typeof AuthenticatedSummaryTimelineIndexRoute
  AuthenticatedWelcomeIndexRoute: typeof AuthenticatedWelcomeIndexRoute
  AuthenticatedWorldModelIndexRoute: typeof AuthenticatedWorldModelIndexRoute
  AuthenticatedProjectsProjectIdSharedItemTypeItemIdRoute: typeof AuthenticatedProjectsProjectIdSharedItemTypeItemIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedMeetingsRoute: AuthenticatedMeetingsRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAgentsAttentionRoute: AuthenticatedAgentsAttentionRoute,
  AuthenticatedAgentsNewTaskRoute: AuthenticatedAgentsNewTaskRoute,
  AuthenticatedArenaArenaIdRoute: AuthenticatedArenaArenaIdRoute,
  AuthenticatedChatsChatIdRoute: AuthenticatedChatsChatIdRoute,
  AuthenticatedChatsAllRoute: AuthenticatedChatsAllRoute,
  AuthenticatedJournalJournalIdRoute: AuthenticatedJournalJournalIdRoute,
  AuthenticatedPPluginIdRoute: AuthenticatedPPluginIdRoute,
  AuthenticatedPeopleWikiPersonIdRoute: AuthenticatedPeopleWikiPersonIdRoute,
  AuthenticatedPlaygroundActionCardsV2Route:
    AuthenticatedPlaygroundActionCardsV2Route,
  AuthenticatedPlaygroundCanvasRoute: AuthenticatedPlaygroundCanvasRoute,
  AuthenticatedProjectsProjectIdRoute: AuthenticatedProjectsProjectIdRoute,
  AuthenticatedReportsRoutineIdRoute: AuthenticatedReportsRoutineIdRoute,
  AuthenticatedRoutineChatsRoutineIdRoute:
    AuthenticatedRoutineChatsRoutineIdRoute,
  AuthenticatedRoutinesRoutineIdRoute: AuthenticatedRoutinesRoutineIdRoute,
  AuthenticatedSettingsSectionRoute: AuthenticatedSettingsSectionRoute,
  AuthenticatedSpritesSpriteIdRoute: AuthenticatedSpritesSpriteIdRoute,
  AuthenticatedPlaygroundArtifactsLazyRoute:
    AuthenticatedPlaygroundArtifactsLazyRoute,
  AuthenticatedPlaygroundAskUserQuestionsLazyRoute:
    AuthenticatedPlaygroundAskUserQuestionsLazyRoute,
  AuthenticatedPlaygroundBannerLazyRoute:
    AuthenticatedPlaygroundBannerLazyRoute,
  AuthenticatedPlaygroundBirdThinkingStatesLazyRoute:
    AuthenticatedPlaygroundBirdThinkingStatesLazyRoute,
  AuthenticatedPlaygroundButtonsLazyRoute:
    AuthenticatedPlaygroundButtonsLazyRoute,
  AuthenticatedPlaygroundCalendarLazyRoute:
    AuthenticatedPlaygroundCalendarLazyRoute,
  AuthenticatedPlaygroundColorsLazyRoute:
    AuthenticatedPlaygroundColorsLazyRoute,
  AuthenticatedPlaygroundEditableTablesLazyRoute:
    AuthenticatedPlaygroundEditableTablesLazyRoute,
  AuthenticatedPlaygroundEditorLazyRoute:
    AuthenticatedPlaygroundEditorLazyRoute,
  AuthenticatedPlaygroundEditorFindIsolationLazyRoute:
    AuthenticatedPlaygroundEditorFindIsolationLazyRoute,
  AuthenticatedPlaygroundEditorPreviewParityLazyRoute:
    AuthenticatedPlaygroundEditorPreviewParityLazyRoute,
  AuthenticatedPlaygroundEmptyStatesLazyRoute:
    AuthenticatedPlaygroundEmptyStatesLazyRoute,
  AuthenticatedPlaygroundFastScrollBarLazyRoute:
    AuthenticatedPlaygroundFastScrollBarLazyRoute,
  AuthenticatedPlaygroundFindLazyRoute: AuthenticatedPlaygroundFindLazyRoute,
  AuthenticatedPlaygroundIconsLazyRoute: AuthenticatedPlaygroundIconsLazyRoute,
  AuthenticatedPlaygroundLiveRegionLazyRoute:
    AuthenticatedPlaygroundLiveRegionLazyRoute,
  AuthenticatedPlaygroundMarkdownEditorLazyRoute:
    AuthenticatedPlaygroundMarkdownEditorLazyRoute,
  AuthenticatedPlaygroundMeetingsEmptyStateLazyRoute:
    AuthenticatedPlaygroundMeetingsEmptyStateLazyRoute,
  AuthenticatedPlaygroundNotificationsLazyRoute:
    AuthenticatedPlaygroundNotificationsLazyRoute,
  AuthenticatedPlaygroundReasoningLazyRoute:
    AuthenticatedPlaygroundReasoningLazyRoute,
  AuthenticatedPlaygroundSendDraftCardLazyRoute:
    AuthenticatedPlaygroundSendDraftCardLazyRoute,
  AuthenticatedPlaygroundSmoothdownLazyRoute:
    AuthenticatedPlaygroundSmoothdownLazyRoute,
  AuthenticatedPlaygroundSoundsLazyRoute:
    AuthenticatedPlaygroundSoundsLazyRoute,
  AuthenticatedPlaygroundSubscriptionLazyRoute:
    AuthenticatedPlaygroundSubscriptionLazyRoute,
  AuthenticatedPlaygroundTeamPlanLazyRoute:
    AuthenticatedPlaygroundTeamPlanLazyRoute,
  AuthenticatedPlaygroundToastsLazyRoute:
    AuthenticatedPlaygroundToastsLazyRoute,
  AuthenticatedPlaygroundTranscriptStreamingLazyRoute:
    AuthenticatedPlaygroundTranscriptStreamingLazyRoute,
  AuthenticatedPlaygroundTranscriptionInputDeviceLazyRoute:
    AuthenticatedPlaygroundTranscriptionInputDeviceLazyRoute,
  AuthenticatedPlaygroundTypographyLazyRoute:
    AuthenticatedPlaygroundTypographyLazyRoute,
  AuthenticatedPlaygroundVlistOverlapLazyRoute:
    AuthenticatedPlaygroundVlistOverlapLazyRoute,
  AuthenticatedPlaygroundWhatsNewLazyRoute:
    AuthenticatedPlaygroundWhatsNewLazyRoute,
  AuthenticatedPlaygroundWidgetsLazyRoute:
    AuthenticatedPlaygroundWidgetsLazyRoute,
  AuthenticatedActivityTimelineIndexRoute:
    AuthenticatedActivityTimelineIndexRoute,
  AuthenticatedArenaIndexRoute: AuthenticatedArenaIndexRoute,
  AuthenticatedBirdGameIndexRoute: AuthenticatedBirdGameIndexRoute,
  AuthenticatedChannelSimulatorIndexRoute:
    AuthenticatedChannelSimulatorIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedCkDebugIndexRoute: AuthenticatedCkDebugIndexRoute,
  AuthenticatedDebugIndexRoute: AuthenticatedDebugIndexRoute,
  AuthenticatedEchonotesIndexRoute: AuthenticatedEchonotesIndexRoute,
  AuthenticatedFeedIndexRoute: AuthenticatedFeedIndexRoute,
  AuthenticatedIngestionIndexRoute: AuthenticatedIngestionIndexRoute,
  AuthenticatedIntegrationsIndexRoute: AuthenticatedIntegrationsIndexRoute,
  AuthenticatedJournalIndexRoute: AuthenticatedJournalIndexRoute,
  AuthenticatedMcpInfoIndexRoute: AuthenticatedMcpInfoIndexRoute,
  AuthenticatedMeetingDebugIndexRoute: AuthenticatedMeetingDebugIndexRoute,
  AuthenticatedPeopleWikiIndexRoute: AuthenticatedPeopleWikiIndexRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedRoutineChatsIndexRoute: AuthenticatedRoutineChatsIndexRoute,
  AuthenticatedRoutinesIndexRoute: AuthenticatedRoutinesIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSpritesIndexRoute: AuthenticatedSpritesIndexRoute,
  AuthenticatedSummaryTimelineIndexRoute:
    AuthenticatedSummaryTimelineIndexRoute,
  AuthenticatedWelcomeIndexRoute: AuthenticatedWelcomeIndexRoute,
  AuthenticatedWorldModelIndexRoute: AuthenticatedWorldModelIndexRoute,
  AuthenticatedProjectsProjectIdSharedItemTypeItemIdRoute:
    AuthenticatedProjectsProjectIdSharedItemTypeItemIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface BrowserRequestRouteChildren {
  BrowserRequestBrowserSavedCredentialRequestIdRoute: typeof BrowserRequestBrowserSavedCredentialRequestIdRoute
  BrowserRequestBrowserSignInSignInSessionIdRoute: typeof BrowserRequestBrowserSignInSignInSessionIdRoute
}

const BrowserRequestRouteChildren: BrowserRequestRouteChildren = {
  BrowserRequestBrowserSavedCredentialRequestIdRoute:
    BrowserRequestBrowserSavedCredentialRequestIdRoute,
  BrowserRequestBrowserSignInSignInSessionIdRoute:
    BrowserRequestBrowserSignInSignInSessionIdRoute,
}

const BrowserRequestRouteWithChildren = BrowserRequestRoute._addFileChildren(
  BrowserRequestRouteChildren,
)

interface ChannelsChannelsRouteChildren {
  ChannelsChannelsOnboardingRoute: typeof ChannelsChannelsOnboardingRoute
  ChannelsChannelsUpgradeRoute: typeof ChannelsChannelsUpgradeRoute
  ChannelsChannelsConnectLazyRoute: typeof ChannelsChannelsConnectLazyRoute
  ChannelsChannelsIntegrationsLazyRoute: typeof ChannelsChannelsIntegrationsLazyRoute
  ChannelsChannelsRoutinesLazyRoute: typeof ChannelsChannelsRoutinesLazyRoute
  ChannelsChannelsSettingsLazyRoute: typeof ChannelsChannelsSettingsLazyRoute
  ChannelsChannelsIndexLazyRoute: typeof ChannelsChannelsIndexLazyRoute
}

const ChannelsChannelsRouteChildren: ChannelsChannelsRouteChildren = {
  ChannelsChannelsOnboardingRoute: ChannelsChannelsOnboardingRoute,
  ChannelsChannelsUpgradeRoute: ChannelsChannelsUpgradeRoute,
  ChannelsChannelsConnectLazyRoute: ChannelsChannelsConnectLazyRoute,
  ChannelsChannelsIntegrationsLazyRoute: ChannelsChannelsIntegrationsLazyRoute,
  ChannelsChannelsRoutinesLazyRoute: ChannelsChannelsRoutinesLazyRoute,
  ChannelsChannelsSettingsLazyRoute: ChannelsChannelsSettingsLazyRoute,
  ChannelsChannelsIndexLazyRoute: ChannelsChannelsIndexLazyRoute,
}

const ChannelsChannelsRouteWithChildren =
  ChannelsChannelsRoute._addFileChildren(ChannelsChannelsRouteChildren)

interface ChannelsRouteChildren {
  ChannelsChannelsRoute: typeof ChannelsChannelsRouteWithChildren
}

const ChannelsRouteChildren: ChannelsRouteChildren = {
  ChannelsChannelsRoute: ChannelsChannelsRouteWithChildren,
}

const ChannelsRouteWithChildren = ChannelsRoute._addFileChildren(
  ChannelsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  BrowserRequestRoute: BrowserRequestRouteWithChildren,
  ChannelsRoute: ChannelsRouteWithChildren,
  AccessibilityRoute: AccessibilityRoute,
  DesktopLoginRoute: DesktopLoginRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  OnboardingNewRoute: OnboardingNewRoute,
  SharedArenaRoute: SharedArenaRoute,
  UpgradeRoute: UpgradeRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  LinkLazyRoute: LinkLazyRoute,
  ArtifactTokenRoute: ArtifactTokenRoute,
  AuthCallbackDesktopRoute: AuthCallbackDesktopRoute,
  ChangeEmailVerifyRoute: ChangeEmailVerifyRoute,
  ChannelsSignInRoute: ChannelsSignInRoute,
  ErrorSessionExpiredRoute: ErrorSessionExpiredRoute,
  FTokenRoute: FTokenRoute,
  SharedChatIdRoute: SharedChatIdRoute,
  SharedMeetingIdRoute: SharedMeetingIdRoute,
  TeamJoinRoute: TeamJoinRoute,
  WrappedShareIdRoute: WrappedShareIdRoute,
  AccountDeleteLazyRoute: AccountDeleteLazyRoute,
  AccountSupportLazyRoute: AccountSupportLazyRoute,
  AuthCallbackIndexRoute: AuthCallbackIndexRoute,
  ProjectsJoinTokenRoute: ProjectsJoinTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
